/* eslint-disable no-case-declarations */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/ban-types */

import React from "react";
import ReactDOM from "react-dom";
import { ReactSVG } from "react-svg";
import { TFunction } from "react-i18next";
import i18n from "i18next";

import { MAPS_API_VERSION } from "@utils/parameters";

import { AlertTypesID } from "@shared/constants/alert-types.enum";
import { EventTypesID } from "@shared/constants/event-types.enum";
import { VehicleStatesTypesID } from "@shared/constants/vehicle-states-types.enum";
import { VehicleTypesID } from "@shared/constants/vehicle-types.enum";
import { Status as StatusColor } from "@shared/constants/colors.enum";
import { HardwareTypesID } from "@shared/constants/hardware-types.enum";
import { TRACKER_NO_SIGNAL } from "@shared/constants/system.constants";
import { ProductType } from "@shared/types/product_type";
import { UnitType } from "@shared/types/unit_type.enum";

import { Duration } from "@shared/interfaces/duration.interface";
import { Hardware } from "@shared/interfaces/hardware.interface";
import { Travel } from "@shared/interfaces/travel.interface";
import { Vehicle } from "@shared/interfaces/vehicle.interface";
import { VehicleState } from "@shared/interfaces/vehicle-state.interface";
import { Alert } from "@shared/interfaces/alert.interface";
import { GenericVehicle } from "@shared/interfaces/socket-dto.interface";
import { formatHourMeter, formatOdometer, isVehicleAlertSummary } from "@shared/utils/useful-functions";
import { User } from "@shared/entities/reg_users.entity";
import {
  GlobalMessages,
  ServiceOrderMessages,
  TimelineVehiclesItemMessages,
  VehicleStatusMessages
} from "@shared/languages/interfaces";

import { MarkersVisualizationTypes } from "src/components/Map";

import { AuthProvider } from "@hooks/useAuth";
import { ToastMessage } from "@hooks/useToast";

import * as dateFns from "date-fns";
import { enUS, es, ptBR } from "date-fns/locale";
import $ from "jquery";
import _ from "lodash";

import IconBatteryConnected from "@assets/icons/alerts/battery-connected.svg";
import IconBatteryDisconnected from "@assets/icons/alerts/battery-disconnected.svg";
import IconDescarregamentoIndevido from "@assets/icons/alerts/descarregamento-indevido.svg";
import IconExcessoVelocidade from "@assets/icons/alerts/alert-speed-travel.svg";
import IconInatividadeDeHardware from "@assets/icons/alerts/falha-de-hardware.svg";
import IconBetoneiraDescarregamento from "@assets/icons/betoneira-descarregamento_indevido.svg";
import IconParadaIndevida from "@assets/icons/alerts/parada-indevida.svg";
import IconBetoneira from "@assets/icons/betoneira.svg";
import IconBomba from "@assets/icons/bomba.svg";
import IconPaCarregadeira from "@assets/icons/pa-carregadeira.svg";
import IconVeiculoDeApoio from "@assets/icons/veiculo-de-apoio.svg";
import IconAggregateTruck from "@assets/icons/aggregate-truck-icon.svg";
import IconAggregateTruckFab from "@assets/icons/aggregate-truck-fab.svg";
import IconCaminho from "@assets/stateIcons/A caminho.svg";
import IconDescarregando from "@assets/stateIcons/Descarregando.svg";
import IconLocalConfiavel from "@assets/stateIcons/Em local confiavel.svg";
import IconMaintenanceVehicle from "@assets/icons/maintenance-vehicle.svg";
import IconMaintenance from "@assets/icons/manutencao.svg";
import IconObra from "@assets/stateIcons/Na obra.svg";
import IconRetornando from "@assets/stateIcons/Retorno.svg";
import IconUsina from "@assets/stateIcons/Usina.svg";
import IconNoDestino from "@assets/stateIcons/no-destino.svg";
import IconBlockedVehicle from "@assets/icons/blocked-vehicle.svg";
import IconBlockedVehicleAlert from "@assets/icons/alerts/bloqueio.svg";
import IconJammerAlert from "@assets/icons/alerts/jammer.svg";
import IconConcreteAboutToExpire from "@assets/icons/concrete-about-to-expire.svg";
import IconConcreteExpired from "@assets/icons/concrete-expired.svg";
import IconSmallAggregate from "@assets/icons/concreteRecipeIcons/smallAggregate.svg";
import IconCoarseAggregate from "@assets/icons/concreteRecipeIcons/coarseAggregate.svg";
import IconBinder from "@assets/icons/concreteRecipeIcons/binder.svg";
import IconZMRC from "@assets/icons/alerts/ZMRC.svg";
import IconZMRCPin from "@assets/pins/ZMRC.svg";
import IconTrustedLocationAlert from "@assets/icons/alerts/alert_trust_location.svg";
import IconFuelRefueling from "@assets/icons/alerts/alert-fuel.svg";
import IconTemperatureAlert from "@assets/icons/alerts/alert-temperature.svg";
import { TLanguages } from "@shared/languages/languageData";
import { ReportStatusType } from "@shared/types/report_status_type.enum";
import { ChangeType } from "@shared/types/change_type.enum";

import packageJson from "../../package.json";

export interface StandardReturnObject<T> {
  status: "success" | "alert";
  message: string;
  result?: T
}

class Utils {

  /**
   * Format date and hour
   * @param date Date or Hour or Interval
   * @param type Type of first parameter
   * @param options
   */
  formatDateIfHave = (
    date: Duration | Date | string | undefined,
    type: "fullDate" | "shortDate" | "time" | "date" | "dateDescriptive" | "durationTime" | "durationDescriptiveTime" | "durationIntervalTime" | "year" | "fullDateWithoutYear" | "fullDateWithoutSeconds" | "timeWithoutSeconds",
    options?: {
      durationDescriptiveTime?: {
        onlyMinutes?: boolean;
      }
    }
  ): string | Date => {

    const language = localStorage.getItem("@Fleet:language") ?? "pt-BR";

    // Define locale of date-fns according to language
    const dateFnsDescriptiveLocale = language === "pt-BR" ? ptBR : language === "es" ? es : enUS;

    // Define formats according to language
    const fullDateFormat = language === "en-US" ? "MM/dd/yyyy HH:mm:ss" : "dd/MM/yyyy HH:mm:ss";
    const fullDateWithoutYearFormat = language === "en-US" ? "MM/dd HH:mm:ss" : "dd/MM HH:mm:ss";
    const fullDateWithoutSecondsFormat = language === "en-US" ? "MM/dd/yyyy HH:mm" : "dd/MM/yyyy HH:mm";
    const timeFormat = "HH:mm:ss";
    const dateFormat = language === "en-US" ? "MM/dd/yyyy" : "dd/MM/yyyy";
    const dateDescriptiveFormat = language === "en-US" ? "LLLL d" : "d 'de' LLLL";
    const timeWithoutSeconds = language === "en-US" ? "HH'h'MM" : "HH'h'MM";
    const shortDate = language === "en-US" ? "MM/dd/yy" : "dd/MM/yy";

    let intervalDate;

    if (!date) return "";
    if (_.isObject(date)) intervalDate = date as Duration;
    else intervalDate = date as Date | string;

    switch (type) {
    case "fullDate":
      return dateFns.format(new Date(intervalDate), fullDateFormat);
    case "shortDate":
      return dateFns.format(new Date(intervalDate), shortDate);
    case "fullDateWithoutYear":
      return dateFns.format(new Date(intervalDate), fullDateWithoutYearFormat);
    case "fullDateWithoutSeconds":
      return dateFns.format(new Date(intervalDate), fullDateWithoutSecondsFormat);
    case "time":
      return dateFns.format(new Date(intervalDate), timeFormat);
    case "date":
      return dateFns.format(new Date(intervalDate), dateFormat);
    case "year":
      return dateFns.format(new Date(intervalDate), "yyyy");
    case "dateDescriptive":
      return dateFns.format(new Date(intervalDate), dateDescriptiveFormat, { locale: dateFnsDescriptiveLocale });
    case "timeWithoutSeconds":
      return dateFns.format(new Date(intervalDate), timeWithoutSeconds);
    case "durationDescriptiveTime": {
      const duration = date as Duration;
      let formattedTime = "";
      const hours = duration.hours || 0;
      const minutes = duration.minutes || 0;
      const seconds = duration.seconds || 0;

      if (hours > 0) formattedTime += `${hours}h `;
      if (minutes > 0) formattedTime += `${minutes}m `;
      if (hours === 0 && minutes === 0) {
        if (options && options[type]?.onlyMinutes) formattedTime = i18n.t(TimelineVehiclesItemMessages.rightNow);
        else formattedTime += `${seconds}s`;
      }

      return formattedTime;
    }
    case "durationIntervalTime":

      // eslint-disable-next-line no-case-declarations
      const initialDate = { hours: "00", minutes: "00", seconds: "00" };

      Object.keys(intervalDate).forEach((key) => initialDate[key] = intervalDate[key].toString().padStart(2, "0"));

      return `${initialDate.hours}:${initialDate.minutes}:${initialDate.seconds}`;

    default:
      return "";
    }
  };

  /**
   * Format label of autocomplete input of travel
   * @param travel Travel
   */
  formatAutoCompleteTravelLabel = (travel: Travel): string => {

    let description = `[ ${this.formatDateIfHave(travel?.registration_date,
      "fullDateWithoutYear")} ] ${travel?.end?.name ?? travel?.end?.address}`;

    if (travel.num_doc) {
      description = `[ ${this.formatDateIfHave(travel?.document_date,
        "fullDateWithoutYear")} ] (${travel.num_doc}) ${travel.description}`;
    } else if (travel.destination) {
      description = `[ ${this.formatDateIfHave(travel?.registration_date,
        "fullDateWithoutYear")} ] ${travel.destination.address}`;
    }

    return description;
  }

  /**
   * Show or Hide the drawer map
   * @param action Action show or hide drawer map
   * @param elDrawerRender el drawer map
   * @param elStaticRender el static map
   * @param mapComponent Map component
   */
  showDrawerMap = (action: "show" | "hide", elDrawerRender: string, elStaticRender: string, mapComponent: any) => {

    const timeLineItemDetailsMap = document.querySelector(elDrawerRender);

    /** Set visible parameter map
     * @param map
     */
    const FsetMapShow = (map: "static" | "drawer") => {

      $(elStaticRender).addClass("hidden");
      $(elDrawerRender).addClass("hidden");

      if (map === "static") $(elStaticRender).removeClass("hidden");
      else $(elDrawerRender).removeClass("hidden");

    };

    FsetMapShow("drawer");

    if (action === "show") {
      ReactDOM.render(
        <AuthProvider>
          {mapComponent}
        </AuthProvider>,
        timeLineItemDetailsMap
      );
    } else FsetMapShow("static");
  }

  /**
   * Calc the duration (range) between two dates
   * @param dateA
   * @param dateB
   */
  calcDataRange = (dateA: Date, dateB: Date /* , justMinutesFormat = false */) => {

    if (!dateA || !dateB) return "";

    const difSeconds = dateFns.differenceInSeconds(new Date(dateB), new Date(dateA));
    const secNum = parseInt(difSeconds.toString(), 10);
    const hours = Math.floor(secNum / 3600);
    const minutes = Math.floor(secNum / 60) % 60;
    const seconds = secNum % 60;

    return { hours, minutes, seconds } as Duration;
  }

  /**
   * Calc the duration (range) from seconds
   * @param seconds Seconds
   */
  calcDataRangeFromSeconds = (seconds: number) => {

    const secNum = parseInt(seconds.toString(), 10);
    const hours = Math.floor(secNum / 3600);
    const minutes = Math.floor(secNum / 60) % 60;
    const sec = secNum % 60;

    return { hours, minutes, seconds: sec } as Duration;
  }

  /**
   * Return color based on hardware and alert
   * @param vehicle Vehicle object with status (alerts) and state (in case is blocked)
   * @param user User logged
   * @param improperDischarge Alerts reference improper discharge
   */
  getVehicleIconColor = (vehicle: GenericVehicle, user: User, improperDischarge: Alert[] = []): string => {

    const tracker = !_.isEmpty(vehicle.hardwares) ? vehicle.hardwares[0] : null;

    const colors = {
      red: "#F00",
      yellow: "#D9FF00",
      green: "#64DD17",
      gray: "#A3A3A3",
      maintenance: "#666666"
    };

    if (vehicle.blocked) return colors.red;
    if (vehicle.maintenance) return colors.maintenance;
    if (tracker && !tracker.active) return colors.gray;
    if (improperDischarge.length > 0
      && improperDischarge.find((alert) => alert.vehicle && alert.vehicle.code === vehicle.code)
    ) return colors.red;
    if ((!isVehicleAlertSummary(vehicle) && !_.isEmpty(vehicle?.alerts))
      || (isVehicleAlertSummary(vehicle) && vehicle?.summary_alerts?.has_alerts)) return colors.yellow;

    return colors.green;
  }

  /**
   * Return vehicle icon based on vehicle type
   * @param vehicleTypeID
   */
  getVehicleIconAccordingType = (vehicleTypeID: string) => {
    switch (vehicleTypeID) {
    case VehicleTypesID.BETONEIRA:
      return <ReactSVG className="iconBT" src={IconBetoneira} />;
    case VehicleTypesID.CAMINHAO_BOMBA:
      return <ReactSVG className="iconBM" src={IconBomba} />;
    case VehicleTypesID.VEICULO_DE_APOIO:
      return <ReactSVG className="iconVA" src={IconVeiculoDeApoio} />;
    case VehicleTypesID.PA_CARREGADEIRA:
      return <ReactSVG className="iconPC" src={IconPaCarregadeira} />;
    case VehicleTypesID.CARRETA_AGREGADOS:
      return <ReactSVG className="iconCA" src={IconAggregateTruck} />;
    case VehicleTypesID.CARRETA_SILO:
      return <ReactSVG className="iconCA" src={IconAggregateTruck} />;
    default:
      return "?";
    }
  }

  /**
   * Return vehicle icon based on vehicle type and current alert
   * @param vehicle Vehicle object
   * @param improperDischarge
   */
  getVehicleIconAccordingTypeAndAlert = (vehicle: GenericVehicle, improperDischarge: Alert[] = []) => {

    let vehicleIcon = <ReactSVG className="iconBT" src={IconBetoneira} />;
    const vehicleTypeID = vehicle.type.id_vehicle_type;
    const hasImproperDischarge = improperDischarge.length > 0
      && improperDischarge.find((alert) => alert.vehicle && alert.vehicle.code === vehicle.code);

    if (vehicle.blocked) {
      vehicleIcon = <ReactSVG className="iconBlocked" src={IconBlockedVehicle} />;
    } else if (vehicle.maintenance) {
      vehicleIcon = <ReactSVG className="iconMaintenance" src={IconMaintenanceVehicle} />;
    } else if (vehicleTypeID === VehicleTypesID.BETONEIRA) {

      if (hasImproperDischarge) vehicleIcon = <ReactSVG className="iconBT" src={IconBetoneiraDescarregamento} />;
      else vehicleIcon = <ReactSVG className="iconBT" src={IconBetoneira} />;

    } else if (vehicleTypeID === VehicleTypesID.CAMINHAO_BOMBA) {
      vehicleIcon = <ReactSVG className="iconBM" src={IconBomba} />;
    } else if (vehicleTypeID === VehicleTypesID.VEICULO_DE_APOIO) {
      vehicleIcon = <ReactSVG className="iconVA" src={IconVeiculoDeApoio} />;
    } else if (vehicleTypeID === VehicleTypesID.PA_CARREGADEIRA) {
      vehicleIcon = <ReactSVG className="iconPC" src={IconPaCarregadeira} />;
    } else if (vehicleTypeID === VehicleTypesID.CARRETA_AGREGADOS) {
      vehicleIcon = <ReactSVG className="iconCA" src={IconAggregateTruck} />;
    } else if (vehicleTypeID === VehicleTypesID.CARRETA_SILO) {
      vehicleIcon = <ReactSVG className="iconCA" src={IconAggregateTruck} />;
    }

    return vehicleIcon;
  }

  /**
   * Return color based on State
   * @param stateTypeID
   */
  getStateColor = (stateTypeID: string) => {

    switch (stateTypeID) {
    case VehicleStatesTypesID.EM_LOCAL_CONFIAVEL:
      return "#666666";
    case VehicleStatesTypesID.NA_USINA:
      return "#46C17D";
    case VehicleStatesTypesID.A_CAMINHO:
      return "#7E73F8";
    case VehicleStatesTypesID.EM_OBRA || VehicleStatesTypesID.NO_DESTINO:
      return "#C7B301";
    case VehicleStatesTypesID.DESCARREGANDO:
      return "#616161";
    case VehicleStatesTypesID.RETORNANDO:
      return "#E64A19";
    default:
      return "#666666";
    }
  }

  /**
   * Return icon based on State
   * @param stateTypeID
   */
  getStateIcon = (stateTypeID: string) => {
    switch (stateTypeID) {
    case VehicleStatesTypesID.EM_LOCAL_CONFIAVEL:
      return <ReactSVG src={IconLocalConfiavel} />;
    case VehicleStatesTypesID.NA_USINA:
      return <ReactSVG src={IconUsina} />;
    case VehicleStatesTypesID.A_CAMINHO:
      return <ReactSVG src={IconCaminho} />;
    case VehicleStatesTypesID.EM_OBRA:
      return <ReactSVG src={IconObra} />;
    case VehicleStatesTypesID.NO_DESTINO:
      return <ReactSVG src={IconNoDestino} />;
    case VehicleStatesTypesID.DESCARREGANDO:
      return <ReactSVG src={IconDescarregando} />;
    case VehicleStatesTypesID.RETORNANDO:
      return <ReactSVG src={IconRetornando} />;

    default:
      return "?";
    }
  }

  /**
   * Get alert icon based on alert type
   * @param alertTypeID One alert type ID of Alerts Enum
   * @returns Alert icon in ReactSVG format
   */
  getAlertIconAccordingType = (alertTypeID: string): JSX.Element | "?" => {
    switch (alertTypeID) {
    case AlertTypesID.PARADA_INDEVIDA:
      return <ReactSVG src={IconParadaIndevida} />;
    case AlertTypesID.DESCARREGAMENTO_INDEVIDO:
      return <ReactSVG src={IconDescarregamentoIndevido} />;
    case AlertTypesID.INATIVIDADE_DE_HARDWARE:
      return <ReactSVG src={IconInatividadeDeHardware} />;
    case AlertTypesID.EXCESSO_DE_VELOCIDADE:
    case AlertTypesID.EXCESSO_DE_VELOCIDADE_VIAGEM:
      return <ReactSVG src={IconExcessoVelocidade} />;
    case AlertTypesID.CONEXAO_DE_BATERIA_PRINCIPAL:
      return <ReactSVG src={IconBatteryConnected} />;
    case AlertTypesID.DESCONEXAO_DE_BATERIA_PRINCIPAL:
      return <ReactSVG src={IconBatteryDisconnected} />;
    case AlertTypesID.BLOQUEIO:
      return <ReactSVG src={IconBlockedVehicleAlert} />;
    case AlertTypesID.JAMMING_DETECTADO:
      return <ReactSVG src={IconJammerAlert} />;
    case AlertTypesID.CONCRETO_PROXIMO_AO_VENCIMENTO:
      return <ReactSVG src={IconConcreteAboutToExpire} />;
    case AlertTypesID.CONCRETO_VENCIDO:
      return <ReactSVG src={IconConcreteExpired} />;
    case AlertTypesID.MANUTENCAO:
      return <ReactSVG src={IconMaintenance} className="maintenance" />;
    case AlertTypesID.ZMRC:
      return <ReactSVG src={IconZMRC} />;
    case AlertTypesID.ENTRADA_EM_LOCAL_CONFIAVEL:
      return <ReactSVG src={IconTrustedLocationAlert} />;
    case AlertTypesID.ABASTECIMENTO_COMBUSTIVEL:
      return <ReactSVG src={IconFuelRefueling} style={{ fill: "green" }} />;
    case AlertTypesID.QUEDA_BRUSCA_COMBUSTIVEL:
      return <ReactSVG src={IconFuelRefueling} style={{ fill: "#FF0000" }} />;
    case AlertTypesID.EXCESSO_DE_TEMPERATURA:
      return <ReactSVG src={IconTemperatureAlert} />;
    default:
      return "?";
    }
  }

  /**
   * Get color used to describe a state
   * @param vehicleStateTypeID
   */
  getColorAccordingState = (vehicleStateTypeID: string | undefined) => {

    switch (vehicleStateTypeID) {
    case VehicleStatesTypesID.NA_USINA:
      return "rgb(70, 193, 125)";
    case VehicleStatesTypesID.A_CAMINHO:
      return "rgb(126, 115, 248)";
    case VehicleStatesTypesID.EM_OBRA:
    case VehicleStatesTypesID.NO_DESTINO:
      return "rgb(199, 179, 1)";
    case VehicleStatesTypesID.DESCARREGANDO:
      return "rgb(97, 97, 97)";
    case VehicleStatesTypesID.RETORNANDO:
      return "rgb(230, 74, 25)";
    case VehicleStatesTypesID.EM_LOCAL_CONFIAVEL:
      return "rgb(158, 158, 158)";
    default:
      return "black";
    }
  };

  /**
   * Returns vehicle icon according to type and state
   * @param vehicle Vehicle data
   * @param vehicleState State of vehicle
   * @returns Icon in ReactSVG format
   */
  getVehicleIconAccordingTypeAndState = (vehicle: Vehicle | undefined, vehicleState: VehicleState | undefined) => {

    switch (vehicle?.type.id_vehicle_type) {
    case VehicleTypesID.BETONEIRA:
      return (
        <ReactSVG
          className="iconBT"
          src={IconBetoneira}
          style={{
            background: this.getColorAccordingState(vehicleState?.status.id_vehicle_state_type)
          }}
        />
      );
    case VehicleTypesID.CAMINHAO_BOMBA:
      return (
        <ReactSVG
          className="iconBM"
          src={IconBomba}
          style={{
            background: this.getColorAccordingState(vehicleState?.status.id_vehicle_state_type)
          }}
        />
      );
    case VehicleTypesID.VEICULO_DE_APOIO:
      return (
        <ReactSVG
          className="iconVA"
          src={IconVeiculoDeApoio}
          style={{
            background: this.getColorAccordingState(vehicleState?.status.id_vehicle_state_type)
          }}
        />
      );
    case VehicleTypesID.PA_CARREGADEIRA:
      return (
        <ReactSVG
          className="iconPC"
          src={IconPaCarregadeira}
          style={{
            background: this.getColorAccordingState(vehicleState?.status.id_vehicle_state_type)
          }}
        />
      );
    case VehicleTypesID.CARRETA_AGREGADOS:
    case VehicleTypesID.CARRETA_SILO:
      return (
        <ReactSVG
          className="iconCA"
          src={IconAggregateTruckFab}
          style={{
            background: this.getColorAccordingState(vehicleState?.status.id_vehicle_state_type)
          }}
        />
      );
    default:
      return "?";
    }
  }

  /**
   * Return marker icon based on Vehicle
   * @param stateTypeID stateTypeID key that references the state
   */
  getMarkerAccordingVehicleState = (stateTypeID: string) => {

    const color = this.getStateColor(stateTypeID).replace("#", "%23");

    switch (stateTypeID) {
    case VehicleStatesTypesID.A_CAMINHO:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56.652' height='80.932' viewBox='0 0 56.652 80.932'%3E%3Cg id='Grupo_1338' data-name='Grupo 1338' transform='translate(-308 -2554)'%3E%3Cpath id='Caminho_924' fill='${color}' data-name='Caminho 924' d='M213.774,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605S242.1,530.178,242.1,508.934A28.3,28.3,0,0,0,213.774,480.607Z' transform='translate(122.553 2073.393)'/%3E%3Cg id='Grupo_1221' data-name='Grupo 1221' transform='translate(-46.374 2378.964)'%3E%3Cpath id='Caminho_880' data-name='Caminho 880' d='M389.2,190.7l12.4,12.4-12.4,12.4v-6.8H375.031l4.666-11.2H389.2Z' transform='translate(2.106 0)' fill='%23fff'/%3E%3Cpath id='Caminho_881' data-name='Caminho 881' d='M373.121,207.283H362.373l4.665-10.747h10.748Z' transform='translate(0.001 0.97)' fill='%23fff'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A`;
    case VehicleStatesTypesID.DESCARREGANDO:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56.652' height='80.932' viewBox='0 0 56.652 80.932'%3E%3Cg id='Grupo_1337' data-name='Grupo 1337' transform='translate(-403 -2554)'%3E%3Cpath id='Caminho_925' fill='${color}' data-name='Caminho 925' d='M213.774,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605S242.1,530.178,242.1,508.934A28.3,28.3,0,0,0,213.774,480.607Z' transform='translate(217.553 2073.393)'/%3E%3Cpath id='Caminho_894' data-name='Caminho 894' d='M532.23,206.05h-.161v-6.329a4.054,4.054,0,0,0-.147-1.133,3.845,3.845,0,0,0-3.785-2.784c-2.186-.007-4.372,0-6.558,0a1.092,1.092,0,0,0-.161.008,6.715,6.715,0,0,0-.207-1.137,3.517,3.517,0,0,0-1.837-2.637c-.094-.044-.18-.1-.271-.156a28.794,28.794,0,0,0-5.959-2.461v10.208h4.925l-8.978,8.977-8.978-8.977h4.925V188.281a33.227,33.227,0,0,0-9.386,1.305,1.837,1.837,0,0,0-.819.474,6.793,6.793,0,0,0-1.865,3.627,11.64,11.64,0,0,0,.019,4.314,1.731,1.731,0,0,0,.506,1.127,31.54,31.54,0,0,0,4.134,3.178c-1.612.4-3.383.855-3.383.855a.6.6,0,0,0-.6.6v6.978l3.362,0a2.89,2.89,0,0,0-.043.581,3,3,0,0,0,5.991-.094,2.959,2.959,0,0,0-.056-.482h1.394a3.049,3.049,0,0,0-.043.568,3,3,0,0,0,6.007-.06,2.942,2.942,0,0,0-.051-.5l12.489,0a3,3,0,1,0,5.953.467,2.93,2.93,0,0,0-.051-.467h4.081a.991.991,0,0,0,.155-.022v-4.1A.6.6,0,0,0,532.23,206.05Z' transform='translate(-80.777 2379.719)' fill='%23fff'/%3E%3C/g%3E%3C/svg%3E%0A`;
    case VehicleStatesTypesID.EM_LOCAL_CONFIAVEL:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56.652' height='80.932' viewBox='0 0 56.652 80.932'%3E%3Cg id='Grupo_1306' data-name='Grupo 1306' transform='translate(-760.681 -2412)'%3E%3Cpath id='Caminho_915' fill='${color}' data-name='Caminho 915' d='M526.842,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605s28.325-31.361,28.325-52.605A28.306,28.306,0,0,0,526.842,480.607Z' transform='translate(262.166 1931.393)'/%3E%3Cpath id='Caminho_916' data-name='Caminho 916' d='M517.318,514.932,537.171,494.9l-4.256-4.287-15.6,15.748L511.025,500l-4.256,4.287Z' transform='translate(267.037 1937.297)' fill='%23fff'/%3E%3C/g%3E%3C/svg%3E%0A`;
    case VehicleStatesTypesID.EM_OBRA:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56.652' height='80.932' viewBox='0 0 56.652 80.932'%3E%3Cg id='Grupo_1304' data-name='Grupo 1304' transform='translate(-580.985 -2412)'%3E%3Cpath id='Caminho_913' fill='${color}' data-name='Caminho 913' d='M429.378,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605S457.7,530.178,457.7,508.934A28.3,28.3,0,0,0,429.378,480.607Z' transform='translate(179.934 1931.393)'/%3E%3Cg id='Grupo_1257' data-name='Grupo 1257' transform='translate(589.772 2423.599)'%3E%3Cg id='Grupo_1256' data-name='Grupo 1256' transform='translate(0 11.765)'%3E%3Crect id='Retângulo_172' data-name='Retângulo 172' width='18.378' height='9.411' rx='1.505' fill='%23fff'/%3E%3Crect id='Retângulo_173' data-name='Retângulo 173' width='18.378' height='9.411' rx='1.505' transform='translate(20.699)' fill='%23fff'/%3E%3C/g%3E%3Crect id='Retângulo_174' data-name='Retângulo 174' width='18.378' height='9.411' rx='1.505' transform='translate(10.349)' fill='%23fff'/%3E%3Crect id='Retângulo_175' data-name='Retângulo 175' width='18.378' height='9.411' rx='1.505' transform='translate(10.349 23.53)' fill='%23fff'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A`;
    case VehicleStatesTypesID.NA_USINA:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56.652' height='80.932' viewBox='0 0 56.652 80.932'%3E%3Cg id='Grupo_1339' data-name='Grupo 1339' transform='translate(-220 -2554)'%3E%3Cpath id='Caminho_905' fill='${color}' data-name='Caminho 905' d='M213.774,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605S242.1,530.178,242.1,508.934A28.3,28.3,0,0,0,213.774,480.607Z' transform='translate(34.553 2073.393)'/%3E%3Cg id='Grupo_1328' data-name='Grupo 1328' transform='translate(1 0.492)'%3E%3Cpath id='Caminho_882' data-name='Caminho 882' d='M466.63,196.689H445.08a2.279,2.279,0,0,0-2.279,2.279v3.963a2.271,2.271,0,0,0,1.975,2.248v13.293H452.1v-6.881h7.517v6.881h7.323V205.179a2.272,2.272,0,0,0,1.972-2.248v-3.963A2.279,2.279,0,0,0,466.63,196.689Z' transform='translate(-200.908 2379.39)' fill='%23fff'/%3E%3Cpath id='Caminho_883' data-name='Caminho 883' d='M443,192.02a4.63,4.63,0,0,0-4.593-4.149H438.4a4.63,4.63,0,0,0-4.6,4.149h-.05v14.446a4.625,4.625,0,0,0,1.9,3.726l-1.881,12.033h9.254l-1.883-12.033a4.624,4.624,0,0,0,1.9-3.732V192.02Z' transform='translate(-204.756 2375.638)' fill='%23fff'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A`;
    case VehicleStatesTypesID.RETORNANDO:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56.652' height='80.932' viewBox='0 0 56.652 80.932'%3E%3Cg id='Grupo_1336' data-name='Grupo 1336' transform='translate(-493 -2554)'%3E%3Cpath id='Caminho_926' fill='${color}' data-name='Caminho 926' d='M213.774,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605S242.1,530.178,242.1,508.934A28.3,28.3,0,0,0,213.774,480.607Z' transform='translate(307.553 2073.393)'/%3E%3Cg id='Grupo_1330' data-name='Grupo 1330' transform='translate(410 10260)'%3E%3Cpath id='Caminho_896' data-name='Caminho 896' d='M562.9,185.966a16.163,16.163,0,0,0-14.794,9.69h5.524a11.333,11.333,0,1,1-.743,11.629l5.168-5.169H545.135v12.921l4.2-4.2A16.141,16.141,0,1,0,562.9,185.966Z' transform='translate(-451.135 -7880.966)' fill='%23fff'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A`;
    default:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56.652' height='80.932' viewBox='0 0 56.652 80.932'%3E%3Cg id='Grupo_1306' data-name='Grupo 1306' transform='translate(-760.681 -2412)'%3E%3Cpath id='Caminho_915' fill='${color}' data-name='Caminho 915' d='M526.842,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605s28.325-31.361,28.325-52.605A28.306,28.306,0,0,0,526.842,480.607Z' transform='translate(262.166 1931.393)'/%3E%3Cpath id='Caminho_916' data-name='Caminho 916' d='M517.318,514.932,537.171,494.9l-4.256-4.287-15.6,15.748L511.025,500l-4.256,4.287Z' transform='translate(267.037 1937.297)' fill='%23fff'/%3E%3C/g%3E%3C/svg%3E%0A`;
    }
  };

  /**
   * Return marker icon based on Vehicle Type
   * @param vehicleTypeID vehicleTypeID key that references the vehicle type
   * @param stateTypeID stateTypeID key that references the state
   */
  getMarkerWithIcon = (vehicleTypeID: string, stateTypeID: string) => {
    const color = this.getStateColor(stateTypeID).replace("#", "%23");

    switch (vehicleTypeID) {
    case VehicleTypesID.BETONEIRA:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56.652 81'%3e%3cg id='Grupo_1300' data-name='Grupo 1300' transform='translate(-220 -2412)'%3e%3cpath id='Caminho_905' fill='${color}' data-name='Caminho 905' d='M213.774,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605S242.1,530.178,242.1,508.934A28.3,28.3,0,0,0,213.774,480.607Z' transform='translate(34.553 1931.393)'/%3e%3cg id='Grupo_1251' data-name='Grupo 1251' transform='translate(227.339 2423.266)'%3e%3cpath id='Caminho_906' data-name='Caminho 906' d='M231.406,506.346h-.167v-6.631a4.282,4.282,0,0,0-.154-1.188,4.027,4.027,0,0,0-3.966-2.917c-2.292-.008-4.581,0-6.873,0a1.19,1.19,0,0,0-.167.008,7.038,7.038,0,0,0-.218-1.191,3.69,3.69,0,0,0-1.924-2.764c-.1-.046-.186-.116-.285-.164-10.284-4.955-18.345-4.284-24.576-2.4a2.021,2.021,0,0,0-.859.5,7.113,7.113,0,0,0-1.954,3.8,12.209,12.209,0,0,0,.019,4.521,1.817,1.817,0,0,0,.531,1.182,33.037,33.037,0,0,0,4.33,3.33c-1.689.417-3.545.9-3.545.9a.628.628,0,0,0-.628.628v7.312l3.522,0a3.082,3.082,0,0,0-.045.609,3.14,3.14,0,0,0,6.278-.1,3.3,3.3,0,0,0-.059-.5c.491,0,.98,0,1.461,0a3.066,3.066,0,0,0-.045.595,3.147,3.147,0,1,0,6.24-.587c.751,0,7.6,0,13.088,0a3.14,3.14,0,1,0,6.239.49,3.057,3.057,0,0,0-.054-.488h4.276a1.416,1.416,0,0,0,.164-.024v-4.3A.628.628,0,0,0,231.406,506.346Z' transform='translate(-190.062 -487.692)' fill='%23fff'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e`;
    case VehicleTypesID.CAMINHAO_BOMBA:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56.652 81'%3e%3cg id='Grupo_1303' data-name='Grupo 1303' transform='translate(-490.341 -2412)'%3e%3cpath id='Caminho_911' fill='${color}' data-name='Caminho 911' d='M373.664,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605s28.325-31.361,28.325-52.605A28.306,28.306,0,0,0,373.664,480.607Z' transform='translate(145.004 1931.393)'/%3e%3cpath id='Caminho_912' data-name='Caminho 912' d='M391.3,503.018h-.165V496.6a4.185,4.185,0,0,0-.146-1.15,3.9,3.9,0,0,0-3.84-2.819c-2.2-.008-4.4,0-6.614,0v-2.155a1.188,1.188,0,0,0-1.188-1.186h-27.44l-.5,1.954a1.513,1.513,0,0,1-.868,1.016l-.612.262,2.088,4.445H350.6l1.814,3.244a.6.6,0,0,0-.283.5V507.2a.607.607,0,0,0,.606.607h2.667a2.991,2.991,0,0,0-.043.563,3.042,3.042,0,0,0,6.083-.091,3.088,3.088,0,0,0-.056-.472h1.326a3.1,3.1,0,1,0,6.146.514,3.212,3.212,0,0,0-.054-.514H370.1l0,.011h9.61a.6.6,0,0,0,.162-.011h1.5a3.234,3.234,0,0,0-.054.573,3.1,3.1,0,1,0,6.21-.041,3.25,3.25,0,0,0-.056-.531h1.517a.3.3,0,0,0,.062.014h2.692a1.067,1.067,0,0,0,.157-.022v-4.168A.606.606,0,0,0,391.3,503.018Zm-14.435-10.7v1.3a1.109,1.109,0,0,0,1.108,1.105h.033l2.376-.075c-.081,2.091-.177,5.059-.177,5.059l-11.128-.14-1.36-2.439a1.94,1.94,0,0,0-1.069-.879l6.793-3.926Zm-20.045,0h10.386l-5.631,2.9-5.49-1.08Z' transform='translate(147.714 1936.516)' fill='%23fff'/%3e%3c/g%3e%3c/svg%3e`;
    case VehicleTypesID.VEICULO_DE_APOIO:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56.652 81'%3e%3cg id='Grupo_1301' data-name='Grupo 1301' transform='translate(-310.643 -2412)'%3e%3cpath id='Caminho_907' fill='${color}' data-name='Caminho 907' d='M263.521,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605s28.325-31.361,28.325-52.605A28.306,28.306,0,0,0,263.521,480.607Z' transform='translate(75.449 1931.393)'/%3e%3cpath id='Caminho_908' data-name='Caminho 908' d='M281.214,502.119a3.351,3.351,0,0,0-1.019-2.045,1.391,1.391,0,0,1-.495-1.479,4.256,4.256,0,0,0-.538-3.182c-.259-.423-.5-.856-.749-1.275.456-.181-.747-2.2-1.663-2.39a56.2,56.2,0,0,0-7.733-1.129c-1.883-.127-3.774-.148-5.661-.173a12.608,12.608,0,0,0-5.006.914,26.09,26.09,0,0,0-4.157,2.458,10.878,10.878,0,0,1-4.624,1.744,18.892,18.892,0,0,0-3.922.689,6.78,6.78,0,0,0-4.151,3.289,4.545,4.545,0,0,1-1.423,1.851.357.357,0,0,0-.1.278c.043.657.1,1.314.156,1.97a3.969,3.969,0,0,0,.512,2.08,1.639,1.639,0,0,0,1.59.7h0l.732-.006a3.442,3.442,0,0,0,3.387,2.5,3.5,3.5,0,0,0,3.355-2.568l22.858-.213a3.523,3.523,0,0,0,6.908-.064l.7-.006c.808.01.959-.1,1.131-.833A7.048,7.048,0,0,0,281.214,502.119Z' transform='translate(78.268 1937.199)' fill='%23fff'/%3e%3c/g%3e%3c/svg%3e`;
    case VehicleTypesID.PA_CARREGADEIRA:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56.652' height='81' viewBox='0 0 56.652 81'%3e%3cg id='Grupo_1302' data-name='Grupo 1302' transform='translate(-399.697 -2412)'%3e%3cpath id='Caminho_909' fill='${color}' data-name='Caminho 909' d='M317.9,480.607a28.3,28.3,0,0,0-28.325,28.327c0,21.244,28.325,52.605,28.325,52.605s28.327-31.361,28.327-52.605A28.306,28.306,0,0,0,317.9,480.607Z' transform='translate(110.12 1931.393)'/%3e%3cpath id='Caminho_910' data-name='Caminho 910' d='M338.775,504.9l-1.153-7.487-12.334-1.533-1.7-8.02h-8.521l-1.679,7.547h-1.239l-1.562,2.153-4.327-4.386-.046.016v-.016h-4.146c0-.482,0-.964,0-1.446a1.367,1.367,0,0,0-.472-1.172,7.849,7.849,0,0,1-1.005-1.026,1.407,1.407,0,0,0-1.411-.6,4.479,4.479,0,0,1-.642,0c-1.013,2.729-2.012,5.424-3.012,8.118-.258.7-.534,1.388-.771,2.093-.1.307-.234.5-.587.423-.42-.086-.627.108-.736.506s-.277.773-.442,1.224c.2.014.356.033.509.033,2.018,0,4.038.013,6.056-.011a1.187,1.187,0,0,0,.724-.3,6.325,6.325,0,0,0,1.682-1.787,6.549,6.549,0,0,0,.1-2.4c0-.135,0-.27,0-.406h2.377l1.84,6.218c-.173-.014-.34-.052-.517-.052a5.988,5.988,0,1,0,5.866,7.194h11.656a5.988,5.988,0,0,0,11.731,0H336.8Z' transform='translate(112.138 1935.673)' fill='%23fff'/%3e%3c/g%3e%3c/svg%3e`;
    case VehicleTypesID.CARRETA_AGREGADOS:
    case VehicleTypesID.CARRETA_SILO:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56.652 80.932'%3E%3Cg id='Grupo_1400' data-name='Grupo 1400' transform='translate(-220 -2412)'%3E%3cpath id='Caminho_900' data-name='Caminho 900' d='M213.774,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605S242.1,530.178,242.1,508.934A28.3,28.3,0,0,0,213.774,480.607Z' transform='translate(34.553 1931.393)' fill='${color}' /%3E%3Cg id='Grupo_1351' data-name='Grupo 1351' transform='translate(227.339 2423.266)' fill='%23fff'%3E%3cpath d='M34.4201 24.1464C32.9448 24.1464 31.7503 25.2567 31.7503 26.6279C31.7503 27.9992 32.9448 29.1095 34.4201 29.1095C35.8954 29.1095 37.0899 27.9992 37.0899 26.6279C37.0899 25.2567 35.8954 24.1464 34.4201 24.1464Z'/%3E%3cpath d='M17.7088 27.5788C18.273 26.3126 17.6261 24.861 16.2639 24.3365C14.9016 23.812 13.3399 24.4133 12.7756 25.6795C12.2114 26.9457 12.8582 28.3973 14.2205 28.9218C15.5828 29.4463 17.1445 28.845 17.7088 27.5788Z'/%3E%3cpath d='M4.28258 22.331C4.09665 21.2647 4 20.1707 4 19.0557C4 15.3974 5.0403 11.965 6.86092 9H22.199V22.8842H24.9254V12.4243C24.9254 12.1808 25.091 11.9666 25.3383 11.8867L27.2033 11.2887L27.6141 9.448C27.6141 9.448 34.299 10.1414 36.1663 11.7737H37.3838C37.9349 11.7737 38.4043 12.138 38.5049 12.6405L38.6705 13.48L33.4713 13.2327C33.268 13.2229 33.1004 13.3787 33.1088 13.5677V16.4758C33.1088 16.6686 33.2575 16.8322 33.4608 16.8673L39.3138 17.8627C39.3934 17.8763 39.4668 17.8685 39.536 17.8451L39.5653 17.9912V20.0053H39.865L39.8629 20.0014C40.0892 20.0014 40.2736 20.1728 40.2736 20.3832V22.2239C40.2736 22.4342 40.0892 22.6056 39.8629 22.6056H39.6009V25.8683C39.6009 26.328 39.1986 26.7 38.704 26.7L37.6814 26.6961C37.6792 25.019 36.2081 23.6594 34.408 23.6594C32.6079 23.6594 31.1494 25.0073 31.1347 26.6766L18.5527 26.6377C18.515 24.9878 17.0585 23.6594 15.2815 23.6594C13.5044 23.6594 12.0626 24.9761 12.0123 26.6162H11.9285L9.22936 24.1795C8.97789 23.9516 9.08684 23.5523 9.42845 23.4685C10.1724 23.2854 11.4779 23.038 13.3493 22.9348V22.331H4.28258ZM31.7089 16.6277C31.8807 16.6277 32.0274 16.5206 32.0274 16.3609H32.0253V13.6437C32.0253 13.3534 31.7717 13.1177 31.4595 13.1177H29.5295C29.366 13.1177 29.2381 13.2482 29.2528 13.4002L29.4645 15.5389C29.4645 16.4388 31.1305 16.6277 31.7089 16.6277Z'/%3E%3c/g%3E%3c/g%3E%3c/svg%3E`;
    default:
      return "";
    }
  }

  /**
   * Return marker icon based on Vehicle
   * @param vehicle Vehicle object
   * @param stateTypeID
   * @param visualizationType VisualizationType used to define what info is displayed
   */
  getMarkerAccordingVehicleType = (
    vehicle: GenericVehicle, stateTypeID: string, visualizationType: MarkersVisualizationTypes
  ) => {

    if (visualizationType.name && visualizationType.licensePlate) {
      return this.getMarkerWithNameAndPlate(vehicle, vehicle.type.id_vehicle_type, stateTypeID);
    }

    if (visualizationType.name) {
      return this.getMarkerWithName(vehicle, vehicle.type.id_vehicle_type, stateTypeID);
    }

    if (visualizationType.licensePlate) {
      return this.getMarkerWithLicensePlate(vehicle, vehicle.type.id_vehicle_type, stateTypeID);
    }

    return this.getMarkerWithIcon(vehicle.type.id_vehicle_type, stateTypeID);

  };

  /**
   * Return marker icon based on Alerts
   * @param alertTypeID
   * @param fillColor string color to fill the marker
   */
  getMarkerAccordingVehicleAlert = (alertTypeID: string, fillColor = "#FD0013") => {
    const color = fillColor.replace("#", "%23");

    switch (alertTypeID) {
    case AlertTypesID.PARADA_INDEVIDA:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56.652' height='80.932' viewBox='0 0 56.652 80.932'%3E%3Cg id='Grupo_1342' data-name='Grupo 1342' transform='translate(-668.341 -2554)'%3E%3Cpath id='Caminho_937' fill='${color}' data-name='Caminho 937' d='M213.774,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605S242.1,530.178,242.1,508.934A28.3,28.3,0,0,0,213.774,480.607Z' transform='translate(482.894 2073.393)'/%3E%3Cpath id='Caminho_933' data-name='Caminho 933' d='M49.8,30.542H35.95l-9.8,9.8V54.195l9.8,9.8H49.8l9.8-9.8V40.34ZM52.133,52.5l-4.02,4.02-5.236-5.236-5.235,5.236-4.02-4.02,5.236-5.236-5.236-5.235,4.02-4.02,5.235,5.236,5.236-5.236,4.02,4.02L46.9,47.267Z' transform='translate(654.188 2534.838)' fill='%23fff'/%3E%3C/g%3E%3C/svg%3E%0A`;
    case AlertTypesID.INATIVIDADE_DE_HARDWARE:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56.652' height='80.932' viewBox='0 0 56.652 80.932'%3E%3Cg id='Grupo_1344' data-name='Grupo 1344' transform='translate(-840 -2554)'%3E%3Cpath id='Caminho_946' fill='${color}' data-name='Caminho 946' d='M213.774,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605S242.1,530.178,242.1,508.934A28.3,28.3,0,0,0,213.774,480.607Z' transform='translate(654.553 2073.393)'/%3E%3Cpath id='Caminho_934' data-name='Caminho 934' d='M160.774,164.236v25.635h6.885v5.343H171.1v-5.343h3.442v5.343h3.442v-5.343h3.442v5.343h3.442v-5.343h6.884V164.236Zm24.061,17.1-3.723,3.723-4.849-4.849-4.848,4.849-3.723-3.723,4.849-4.849-4.849-4.848,3.723-3.723,4.848,4.849,4.849-4.849,3.723,3.723-4.849,4.848Z' transform='translate(692.227 2403.615)' fill='%23fff'/%3E%3C/g%3E%3C/svg%3E%0A`;
    case AlertTypesID.EXCESSO_DE_VELOCIDADE:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56.652' height='80.932' viewBox='0 0 56.652 80.932'%3E%3Cg id='Grupo_1341' data-name='Grupo 1341' transform='translate(-580.984 -2554)'%3E%3Cpath id='Caminho_927' fill='${color}' data-name='Caminho 927' d='M213.774,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605S242.1,530.178,242.1,508.934A28.3,28.3,0,0,0,213.774,480.607Z' transform='translate(395.537 2073.393)'/%3E%3Cg id='Grupo_1331' data-name='Grupo 1331' transform='translate(-0.029 -34.783)'%3E%3Cpath id='Caminho_938' data-name='Caminho 938' d='M49.8,232.2H35.95l-9.8,9.8v13.855l9.8,9.8H49.8l9.8-9.8V242Z' transform='translate(566.861 2367.959)' fill='%23fafafa'/%3E%3Cpath id='Caminho_939' data-name='Caminho 939' d='M61.42,254.754s-11.772,9.026-11.95,9.229a2.914,2.914,0,0,0,4.386,3.838C54.033,267.618,61.42,254.754,61.42,254.754Z' transform='translate(557.961 2359.078)'/%3E%3Cpath id='Caminho_940' data-name='Caminho 940' d='M71.119,252.924h2.921a14.38,14.38,0,0,0-3.2-7.692l-2.068,2.053A11.483,11.483,0,0,1,71.119,252.924Z' transform='translate(550.074 2362.828)'/%3E%3Cpath id='Caminho_941' data-name='Caminho 941' d='M61.749,241.836l2.053-2.068a14.38,14.38,0,0,0-7.692-3.2v2.921A11.483,11.483,0,0,1,61.749,241.836Z' transform='translate(555.062 2366.239)'/%3E%3Cpath id='Caminho_942' data-name='Caminho 942' d='M46.341,239.494v-2.921a14.384,14.384,0,0,0-7.692,3.2l2.068,2.068A11.379,11.379,0,0,1,46.341,239.494Z' transform='translate(561.938 2366.239)'/%3E%3Cpath id='Caminho_943' data-name='Caminho 943' d='M33.186,245.232a14.432,14.432,0,0,0-3.2,7.692h2.921a11.482,11.482,0,0,1,2.342-5.639Z' transform='translate(565.348 2362.828)'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A`;
    case AlertTypesID.DESCARREGAMENTO_INDEVIDO:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56.652' height='80.932' viewBox='0 0 56.652 80.932'%3E%3Cg id='Grupo_1343' data-name='Grupo 1343' transform='translate(-760.681 -2554)'%3E%3Cpath id='Caminho_944' fill='${color}' data-name='Caminho 944' d='M213.774,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605S242.1,530.178,242.1,508.934A28.3,28.3,0,0,0,213.774,480.607Z' transform='translate(575.234 2073.393)'/%3E%3Cpath id='Caminho_945' data-name='Caminho 945' d='M123.747,354.182l-9.83,9.829-9.829-9.829a18.171,18.171,0,1,0,19.66,0Zm.392,24.528-4.44,4.439-5.782-5.782-5.782,5.782-4.44-4.439,5.782-5.782-5.782-5.782,4.44-4.44,5.782,5.782,5.782-5.782,4.44,4.44-5.782,5.782Z' transform='translate(674.936 2211.198)' fill='%23fff'/%3E%3C/g%3E%3C/svg%3E%0A`;
    case AlertTypesID.ZMRC:
      return IconZMRCPin;
    default:
      return "";
    }
  }

  /**
   * Return marker icon based on Events
   * @param eventTypeID
   * @param fillColor string color to fill the marker
   */
  getMarkerAccordingVehicleEvent = (eventTypeID: string, fillColor = "#a89423") => {
    const color = fillColor.replace("#", "%23");

    switch (eventTypeID) {
    case EventTypesID.PARADA:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56.652' height='80.932' viewBox='0 0 56.652 80.932'%3E%3Cg id='Grupo_1342' data-name='Grupo 1342' transform='translate(-668.341 -2554)'%3E%3Cpath id='Caminho_937' fill='${color}' data-name='Caminho 937' d='M213.774,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605S242.1,530.178,242.1,508.934A28.3,28.3,0,0,0,213.774,480.607Z' transform='translate(482.894 2073.393)'/%3E%3Cpath id='Caminho_933' data-name='Caminho 933' d='M49.8,30.542H35.95l-9.8,9.8V54.195l9.8,9.8H49.8l9.8-9.8V40.34ZM52.133,52.5l-4.02,4.02-5.236-5.236-5.235,5.236-4.02-4.02,5.236-5.236-5.236-5.235,4.02-4.02,5.235,5.236,5.236-5.236,4.02,4.02L46.9,47.267Z' transform='translate(654.188 2534.838)' fill='%23fff'/%3E%3C/g%3E%3C/svg%3E%0A`;
    case EventTypesID.EXCESSO_DE_VELOCIDADE:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56.652' height='80.932' viewBox='0 0 56.652 80.932'%3E%3Cg id='Grupo_1341' data-name='Grupo 1341' transform='translate(-580.984 -2554)'%3E%3Cpath id='Caminho_927' fill='${color}' data-name='Caminho 927' d='M213.774,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605S242.1,530.178,242.1,508.934A28.3,28.3,0,0,0,213.774,480.607Z' transform='translate(395.537 2073.393)'/%3E%3Cg id='Grupo_1331' data-name='Grupo 1331' transform='translate(-0.029 -34.783)'%3E%3Cpath id='Caminho_938' data-name='Caminho 938' d='M49.8,232.2H35.95l-9.8,9.8v13.855l9.8,9.8H49.8l9.8-9.8V242Z' transform='translate(566.861 2367.959)' fill='%23fafafa'/%3E%3Cpath id='Caminho_939' data-name='Caminho 939' d='M61.42,254.754s-11.772,9.026-11.95,9.229a2.914,2.914,0,0,0,4.386,3.838C54.033,267.618,61.42,254.754,61.42,254.754Z' transform='translate(557.961 2359.078)'/%3E%3Cpath id='Caminho_940' data-name='Caminho 940' d='M71.119,252.924h2.921a14.38,14.38,0,0,0-3.2-7.692l-2.068,2.053A11.483,11.483,0,0,1,71.119,252.924Z' transform='translate(550.074 2362.828)'/%3E%3Cpath id='Caminho_941' data-name='Caminho 941' d='M61.749,241.836l2.053-2.068a14.38,14.38,0,0,0-7.692-3.2v2.921A11.483,11.483,0,0,1,61.749,241.836Z' transform='translate(555.062 2366.239)'/%3E%3Cpath id='Caminho_942' data-name='Caminho 942' d='M46.341,239.494v-2.921a14.384,14.384,0,0,0-7.692,3.2l2.068,2.068A11.379,11.379,0,0,1,46.341,239.494Z' transform='translate(561.938 2366.239)'/%3E%3Cpath id='Caminho_943' data-name='Caminho 943' d='M33.186,245.232a14.432,14.432,0,0,0-3.2,7.692h2.921a11.482,11.482,0,0,1,2.342-5.639Z' transform='translate(565.348 2362.828)'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A`;
    case EventTypesID.DESCARREGAMENTO_INDEVIDO:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56.652' height='80.932' viewBox='0 0 56.652 80.932'%3E%3Cg id='Grupo_1343' data-name='Grupo 1343' transform='translate(-760.681 -2554)'%3E%3Cpath id='Caminho_944' fill='${color}' data-name='Caminho 944' d='M213.774,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605S242.1,530.178,242.1,508.934A28.3,28.3,0,0,0,213.774,480.607Z' transform='translate(575.234 2073.393)'/%3E%3Cpath id='Caminho_945' data-name='Caminho 945' d='M123.747,354.182l-9.83,9.829-9.829-9.829a18.171,18.171,0,1,0,19.66,0Zm.392,24.528-4.44,4.439-5.782-5.782-5.782,5.782-4.44-4.439,5.782-5.782-5.782-5.782,4.44-4.44,5.782,5.782,5.782-5.782,4.44,4.44-5.782,5.782Z' transform='translate(674.936 2211.198)' fill='%23fff'/%3E%3C/g%3E%3C/svg%3E%0A`;
    default:
      return "";
    }
  }

  /**
   * Return marker icon based on Events
   * @param num Number to put inside marker
   * @param fillColor string color to fill the marker
   */
  getMarkerDynamically = (num = 0, fillColor = "#a89423") => {
    const color = fillColor.replace("#", "%23");

    return `data:image/svg+xml;utf8,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2057%2057' transform='rotate(${num} 0 0)'%3E%20%3Cg%20data-name='Elipse%20175'%3E%20%3Ccircle%20cx='28.5'%20cy='28.5'%20r='28.5'%20fill='none'/%3E%20%3Ccircle%20cx='28.5'%20cy='28.5'%20r='27'%20fill='${color}'%20stroke='%23FFF'%20stroke-width='3'/%3E%20%3C/g%3E%20%3Cpath%20d='M28.72,8,44.44,43.38,28.72,32,13,43.38Z'%20fill='%23FFF'/%3E%20%3C/svg%3E`;
  }

  /**
   * Return data from sensor (Color, Status and Description)
   * @param hardware
   * @param returnType
   */
  getHardwareDataStyle = (hardware: Hardware, returnType: "color" | "status" | "description") => {

    switch (returnType) {
    case "color":

      if (hardware.type.id_hardware_type === HardwareTypesID.RASTREADOR) { // Rastreador
        return hardware.active ? StatusColor.ACTIVE : StatusColor.INACTIVE;
      } // Sensor de balão

      const color = StatusColor.ACTIVE;

      // If sensor is idle or inactive
      // If inactive and super admin user = red or gray
      if (hardware.idle || !hardware.active) {
        return StatusColor.INACTIVE;
      }

      return color;

    case "status":

      if (hardware.type.id_hardware_type === HardwareTypesID.RASTREADOR) { // Rastreador
        return hardware.active ? i18n.t(VehicleStatusMessages.active).toUpperCase() : i18n.t(VehicleStatusMessages.inactive).toUpperCase();
      } // Sensor de balão

      const status = i18n.t(VehicleStatusMessages.inMotion).toUpperCase();

      // If sensor is idle or inactive
      // If inactive and super admin user = INATIVO or PARADO
      if (hardware.idle || !hardware.active) {
        return i18n.t(VehicleStatusMessages.stationary).toUpperCase();
      }

      return status;

    case "description":

      return hardware.type.id_hardware_type === HardwareTypesID.RASTREADOR
        ? i18n.t(VehicleStatusMessages.tracker) : i18n.t(VehicleStatusMessages.drum);

    default:
      return "";
    }
  }

  /**
   * Convert a date to ISO format with timezone
   * @param dateToFormat Date to be formated
   * @return string value of converted date in ISO 8601 FORMAT
   */
  convertDateToISOWithTimezone = (dateToFormat: Date) => {

    const tzo = -dateToFormat.getTimezoneOffset();
    const dif = tzo >= 0 ? "+" : "-";
    const pad = (num) => {
      const norm = Math.floor(Math.abs(num));

      return (norm < 10 ? "0" : "") + norm;
    };

    return `${dateToFormat.getFullYear()
    }-${pad(dateToFormat.getMonth() + 1)
    }-${pad(dateToFormat.getDate())
    }T${pad(dateToFormat.getHours())
    }:${pad(dateToFormat.getMinutes())
    }:${pad(dateToFormat.getSeconds())
    }${dif}${pad(tzo / 60)
    }:${pad(tzo % 60)}`;

  }

  /**
   * Convert a date to ISO format
   * @param dateToFormat Date to be formatted
   */
  getDateUTC = (dateToFormat: Date) => {

    const date = new Date(dateToFormat.toString().replace("Z", "-00:00"));
    const dateFormat = date.toLocaleDateString("eng-us", { timeZone: "utc" });

    return new Date(dateFormat);
  }

  /**
   * Convert Ibutton DEV ID to Ibutton code (used to communicate with tracker device)
   * @param devID
   */
  convertDevIDToIbuttonCode = (devID: string) => {

    const array = (devID.trim().toUpperCase()).split("");

    const newArray = [""];

    newArray[0] = array[array.length - 1];
    newArray[1] = array[array.length - 2];

    for (let i = 2; i < array.length; i++) {
      if (i % 2 !== 0) {
        newArray[i] = array[array.length - i];
      } else {
        newArray[i] = array[array.length - 2 - i];
      }

    }

    return newArray.join("");

  }

  /**
   * Get current travel metering info (odometer and hour meter)
   * @param vehicle vehicle data
   * @param type type of travel metering info to be returned
   */
  getCurrentTravelMeteringInfo = (vehicle: GenericVehicle, type: "odometer" | "hourMeter"): string => {

    let total = "0";

    if (type === "odometer") {
      if (vehicle?.current_odometer && vehicle?.current_travel?.start_odometer) {
        total = formatOdometer(
          vehicle.current_odometer - vehicle?.current_travel?.start_odometer, false
        );

        // Return formatted odometer value
        return total;
      }
    }

    if (type === "hourMeter") {
      if (vehicle?.current_hour_meter && vehicle?.current_travel?.start_hour_meter) {
        total = formatHourMeter(
          vehicle.current_hour_meter - vehicle?.current_travel?.start_hour_meter
        );

        // Return formatted hour meter value
        return total;
      }

      // If there is no hour meter info, return "0m"
      return `${total}m`;

    }

    // If there is no info, return "0"
    return total;

  }

  /**
   * Get icon according to product type
   * @param productType
   */
  getIconAccordingProductType = (productType: ProductType | undefined) => {
    switch (productType) {
    case ProductType.SMALL_AGGREGATE:
      return <ReactSVG src={IconSmallAggregate} />;
    case ProductType.COARSE_AGGREGATE:
      return <ReactSVG src={IconCoarseAggregate} />;
    case ProductType.BINDER:
      return <ReactSVG src={IconBinder} />;
    default:
      return <></>;
    }
  }

  /**
   * Get label according to product type
   * @param productType
   */
  getLabelAccordingProductType = (productType: ProductType | undefined) => {

    switch (productType) {
    case ProductType.SMALL_AGGREGATE:
      return i18n.t(ServiceOrderMessages.smallAggregate);
    case ProductType.COARSE_AGGREGATE:
      return i18n.t(ServiceOrderMessages.coarseAggregate);
    case ProductType.BINDER:
      return i18n.t(ServiceOrderMessages.binder);
    default:
      return "";
    }
  }

  /**
   * Get label according to unit type
   * @param unitType
   */
  getLabelAccordingUnitType = (unitType: UnitType | undefined) => {
    switch (unitType) {
    case UnitType.M3:
      return "m³";
    case UnitType.KG:
      return "kg";
    default:
      return "";
    }
  }

  /**
   * Verify if value is a valid number
   * @param value Value to be verified
   */
  isValidNumber = (value?: number) => value || value === 0;

  /**
   * Format number to locale string (pt-BR default) or return empty string if value is undefined
   * @param value Value to be formatted
   * @param language Language to be used
   * @param fractionDigits Number of digits after the decimal point
   */
  formatNumberToLocaleString = (value?: number, language?: TLanguages, fractionDigits?: number) => {
    let formattedValue = "";

    if (value || value === 0) {

      if (fractionDigits || fractionDigits === 0) formattedValue = Number(value).toFixed(fractionDigits);
      else formattedValue = value.toString();

      if (language !== "en-US") formattedValue = formattedValue.replace(".", ",");
    }

    return formattedValue;
  }

  /**
   * Format fuel level value
   * @param value Fuel level value to be formatted (prefix "L" for liters, "P" for percentage)
   */
  formatFuelLevel = (value?: string | null) => {
    if (!value || value === TRACKER_NO_SIGNAL) return "";
    if (value[0] === "L") return `${this.formatNumberToLocaleString(Number(value.slice(1)))} L`;
    if (value[0] === "P") return `${this.formatNumberToLocaleString(Number(value.slice(1)))} %`;

    return value;
  }

  /**
   * Format fuel consumption value
   *
   * The prefix carries the unit ("H" = L/h, "M" = L/100 km). An unknown prefix is shown as a bare
   * number, WITHOUT a unit: the Jmak J-R12 emits "L" in production and its meaning is still pending
   * confirmation from the manufacturer, so no unit may be assumed for it.
   *
   * @param value Fuel consumption value to be formatted
   */
  formatFuelConsumption = (value?: string | null) => {
    if (!value || value === TRACKER_NO_SIGNAL) return "";
    if (value[0] === "H") return `${this.formatNumberToLocaleString(Number(value.slice(1)))} L/h`;
    if (value[0] === "M") return `${this.formatNumberToLocaleString(Number(value.slice(1)))} L/100 km`;
    if (/^[A-Za-z]/.test(value)) return this.formatNumberToLocaleString(Number(value.slice(1)));

    return value;
  }

  /**
   * Verify if vehicle has can bus
   * @param vehicle Vehicle object
   */
  hasCanBus = (vehicle: Vehicle) => {
    if (vehicle?.current_info) {
      return vehicle.current_info?.can_engine !== null
        || this.isValidNumber(vehicle.current_info?.can_odometer)
        || this.isValidNumber(vehicle.current_info?.can_total_fuel_used)
        || this.isValidNumber(vehicle.current_info?.can_speed)
        || this.isValidNumber(vehicle.current_info?.can_engine_rpm)
        || this.isValidNumber(vehicle.current_info?.can_engine_coolant_temperature)
        || this.isValidNumber(vehicle.current_info?.can_total_engine_hours)
        || this.isValidNumber(vehicle.current_info?.can_total_driving_time)
        || this.isValidNumber(vehicle.current_info?.can_total_idle_fuel_used)
        || this.isValidNumber(vehicle.current_info?.can_gross_combination_vehicle_weight)
        || vehicle.current_info?.can_fuel_consumption
        || vehicle.current_info?.can_fuel_level;
    }

    return false;
  }

  /**
   * Simulate click action on a DOM element (First occurrence)
   * @param buttonClass The class of the button
   */
  clickButtonDomElement = (buttonClass: string) => {

    const button = document.getElementsByClassName(buttonClass)[0] as HTMLButtonElement;

    if (button) button.click();
  };

  /**
   * Clean cache data when new version is released
   */
  cleanCacheData = async () => {

    const pkgVersion = packageJson.version;
    const storageVersion = localStorage.getItem("@Fleet:currentVersion");

    if (!storageVersion) {
      localStorage.setItem("@Fleet:currentVersion", pkgVersion);
    } else if (storageVersion !== pkgVersion) {

      localStorage.clear();
      localStorage.setItem("@Fleet:currentVersion", packageJson.version);

      if ("caches" in window) {
        const cacheKeys = await caches.keys();

        await Promise.allSettled(
          cacheKeys.map((name) => caches.delete(name))
        );
      }

      window.location.reload();
    }
  };

  /**
   * Handle standard error using toast
   * @param error Error object
   * @param translationHook Translation function hook
   * @param addToastHook Add toast function hook
   */
  handleStandardError = (
    error: any,
    translationHook: TFunction<"translation", undefined>,
    addToastHook: (message: Omit<ToastMessage, "id">) => void
  ): void => {
    if (error.response) {
      addToastHook({
        type: "error",
        title: error.response.data.backend,
        description: error.response.data.message
      });

      return;
    }

    // An endpoint that answers 200 with { status: "error", message } is a business rule, not a
    // failure: the page rethrows it as a plain Error carrying that message. Without this branch it
    // would be reported as a connection problem, blaming the network for something the server said
    // on purpose — and the user would never read why the action was refused.
    if (!error.isAxiosError && error.message) {
      addToastHook({
        type: "error",
        title: translationHook(GlobalMessages.error),
        description: error.message
      });

      return;
    }

    addToastHook({
      type: "error",
      title: translationHook(GlobalMessages.error),
      description: translationHook(GlobalMessages.connectionNotEstablished)
    });
  };

  /**
   * Get report status type color
   * @param status Report status type
   */
  getReportStatusTypeColor = (status: ReportStatusType): string => {
    switch (status) {
    case ReportStatusType.IN_QUEUE: return "#a09a00";
    case ReportStatusType.PROCESSING: return "#1E90FF";
    case ReportStatusType.PROCESSED: return "#008000";
    case ReportStatusType.ERROR: return "#FF0000";
    case ReportStatusType.CANCELED: return "#FFA500";
    default: return "#000000";
    }
  }

  /**
   * Get change type color
   * @param status Report status type
   */
  getChangeTypeColor = (status: ChangeType): string => {
    switch (status) {
    case ChangeType.CREATE: return "#008000";
    case ChangeType.UPDATE: return "#1E90FF";
    case ChangeType.DELETE: return "#FF0000";
    case ChangeType.CANCEL: return "#FF0000";
    default: return "#000000";
    }
  }

  /**
   * Get utc offset in hours
   */
  getUtcOffset = (): number => {
    const date = new Date();
    const offset = date.getTimezoneOffset();

    return -offset / 60;
  }

  /**
   * Return bool according to the value of the variable
   * @param value Value to be converted (string, number or boolean)
   * @return boolean value
   */
  convertToBoolean = (value: undefined | boolean | number | string): boolean => {

    if (value === undefined) return false;
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") {

      // Normalize value
      if (value.toLowerCase() === "true") return true;
      if (value.toLowerCase() === "false") return false;
    }

    return false;
  }

  /**
   * Load google maps API
   */
  loadGoogleMapsAPI = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (window.google && window.google.maps) {
        resolve();

        return;
      }
      const apiKey = localStorage.getItem("@Fleet:google");
      const language = localStorage.getItem("@Fleet:language");
      const script = document.createElement("script");

      script.src = `https://maps.googleapis.com/maps/api/js?key=${ apiKey }&libraries=places&language=${ language }&v=${ MAPS_API_VERSION }`;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(i18n.t(GlobalMessages.errorLoadingGoogleMaps)));
      document.head.appendChild(script);
    });
  };

  /**
   * Type guard to filter out null values from an array.
   * Can be used inside Array.prototype.filter.
   *
   * @example array.filter(utils.isNotNull)
   */
  isNotNull<T>(value: T | null | undefined): value is T { // <-- SINTAXE CORRETA
    return value !== null && value !== undefined;
  }

  /**
   * Get marker (maps) color according to vehicle type
   * PS: With license plate
   * @param vehicle Vehicle data
   * @param vehicleTypeID Vehicle type ID
   * @param stateTypeID State type ID
   */
  private getMarkerWithLicensePlate = (vehicle: GenericVehicle, vehicleTypeID: string, stateTypeID: string) => {
    const color = this.getStateColor(stateTypeID).replace("#", "%23");
    const licensePlate = vehicle.license_plate;

    switch (vehicleTypeID) {
    case VehicleTypesID.BETONEIRA:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 60 200 80' %3E%3Cg id='Group 170' data-name='Grupo 170'  %3E%3Crect id='Rectangle 135' x='0.256836' y='0.599854' width='199.427' height='55.3551' rx='27.6775' fill='${color}'/%3E%3Cpath id='Caminho 906' d='M28.2576 0.599865C24.5797 0.597136 20.9374 1.31953 17.539 2.72573C14.1405 4.13194 11.0526 6.19435 8.45199 8.79501C5.85133 11.3957 3.78892 14.4835 2.38271 17.882C0.976507 21.2804 0.254114 24.9228 0.256844 28.6006C0.256844 49.6 28.2576 80.5999 28.2576 80.5999C28.2576 80.5999 56.2574 49.6 56.2574 28.6006C56.2609 24.9226 55.5391 21.28 54.1332 17.8813C52.7274 14.4826 50.6651 11.3944 48.0644 8.79362C45.4636 6.19282 42.3756 4.13042 38.9769 2.72444C35.5782 1.31845 31.9356 0.596485 28.2576 0.599865V0.599865Z' fill='${color}'/%3E%3Cg id='Grupo 1252'%3E%3Cpath id='Caminho 906_2' d='M48.3793 30.1755H48.2142V23.6208C48.2187 23.2242 48.1675 22.8289 48.062 22.4465C47.8195 21.5999 47.3031 20.8577 46.5937 20.3359C45.8844 19.8142 45.022 19.5424 44.1416 19.5631C41.876 19.5552 39.6134 19.5631 37.3478 19.5631C37.2927 19.5618 37.2375 19.5645 37.1827 19.571C37.1448 19.1731 37.0727 18.7792 36.9672 18.3937C36.8898 17.8201 36.6769 17.2731 36.3462 16.798C36.0155 16.3229 35.5764 15.9334 35.0654 15.6615C34.9665 15.6161 34.8815 15.5469 34.7837 15.4994C24.6181 10.6015 16.6499 11.2648 10.4907 13.1271C10.1709 13.2186 9.87906 13.3884 9.64158 13.6213C8.62799 14.6458 7.95373 15.9571 7.71008 17.3775C7.43807 18.8554 7.44444 20.371 7.72886 21.8465C7.75429 22.2872 7.94114 22.7031 8.25375 23.0149C9.58715 24.2283 11.0188 25.3293 12.5339 26.3065C10.8643 26.7187 9.02972 27.1962 9.02972 27.1962C8.86508 27.1962 8.70717 27.2615 8.59075 27.378C8.47434 27.4944 8.40894 27.6523 8.40894 27.8169V35.0447H11.8904C11.8557 35.2434 11.8408 35.4451 11.8459 35.6467C11.8748 36.4589 12.221 37.2273 12.8102 37.787C13.3994 38.3466 14.1846 38.6529 14.9972 38.6399C15.8098 38.627 16.5849 38.2959 17.156 37.7178C17.7271 37.1396 18.0486 36.3605 18.0516 35.5479C18.0448 35.3819 18.0253 35.2166 17.9933 35.0536C18.4786 35.0536 18.962 35.0536 19.4375 35.0536C19.4035 35.2478 19.3886 35.4447 19.393 35.6418C19.3939 36.0743 19.485 36.5019 19.6604 36.8972C19.8359 37.2925 20.0919 37.647 20.412 37.9378C20.7322 38.2286 21.1095 38.4495 21.5198 38.5863C21.9301 38.7231 22.3644 38.7729 22.7951 38.7324C23.2257 38.6919 23.6432 38.562 24.0208 38.3511C24.3984 38.1401 24.7278 37.8528 24.9881 37.5073C25.2484 37.1619 25.4338 36.766 25.5325 36.3448C25.6311 35.9237 25.6409 35.4866 25.5611 35.0615C26.3035 35.0615 33.0736 35.0615 38.4984 35.0615C38.4293 35.4853 38.4488 35.9188 38.5558 36.3347C38.6628 36.7505 38.8549 37.1396 39.12 37.4773C39.385 37.8151 39.7173 38.0943 40.0958 38.2971C40.4742 38.4999 40.8907 38.6219 41.3187 38.6555C41.7468 38.6891 42.1771 38.6336 42.5826 38.4924C42.9881 38.3511 43.3599 38.1273 43.6744 37.8351C43.989 37.5428 44.2395 37.1885 44.4101 36.7944C44.5807 36.4004 44.6677 35.9752 44.6655 35.5459C44.6607 35.3839 44.6429 35.2226 44.6122 35.0635H48.8389C48.8934 35.0587 48.9475 35.0508 49.001 35.0398V30.7893C48.9992 30.6257 48.9329 30.4694 48.8164 30.3545C48.7 30.2395 48.5429 30.1752 48.3793 30.1755V30.1755Z' fill='white'/%3E%3C/g%3E%3Ctext id='ANQ0678' fill='white' xml:space='preserve' style='white-space: pre' font-family='Roboto, Open Sans, Noto Sans Adlam, sans' font-size='26' font-weight='500' letter-spacing='0em'%3E%3Ctspan x='61.2957' y='37.5435'%3E${licensePlate}%3C/tspan%3E%3C/text%3E%3C/g%3E%3C/svg%3E`;
    case VehicleTypesID.CAMINHAO_BOMBA:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 60 200 80'%3E%3Cg id='Group 170' data-name='Grupo 170'  %3E%3Crect id='Rectangle 135' x='0.256836' y='0.599854' width='199.427' height='55.3551' rx='27.6775' fill='${color}'/%3E%3Cpath id='Caminho 906' d='M28.2576 0.599865C24.5797 0.597136 20.9374 1.31953 17.539 2.72573C14.1405 4.13194 11.0526 6.19435 8.45199 8.79501C5.85133 11.3957 3.78892 14.4835 2.38271 17.882C0.976507 21.2804 0.254114 24.9228 0.256844 28.6006C0.256844 49.6 28.2576 80.5999 28.2576 80.5999C28.2576 80.5999 56.2574 49.6 56.2574 28.6006C56.2609 24.9226 55.5391 21.28 54.1332 17.8813C52.7274 14.4826 50.6651 11.3944 48.0644 8.79362C45.4636 6.19282 42.3756 4.13042 38.9769 2.72444C35.5782 1.31845 31.9356 0.596485 28.2576 0.599865V0.599865Z' fill='${color}'/%3E%3Cg id='Grupo_1303' data-name='Grupo 1303' transform='translate(-490.341 -2412)'%3E%3Cpath id='Caminho_911' fill='${color}' data-name='Caminho 911' d='M373.664,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605s28.325-31.361,28.325-52.605A28.306,28.306,0,0,0,373.664,480.607Z' transform='translate(145.004 1931.393)'/%3E%3Cpath id='Caminho_912' data-name='Caminho 912' d='M391.3,503.018h-.165V496.6a4.185,4.185,0,0,0-.146-1.15,3.9,3.9,0,0,0-3.84-2.819c-2.2-.008-4.4,0-6.614,0v-2.155a1.188,1.188,0,0,0-1.188-1.186h-27.44l-.5,1.954a1.513,1.513,0,0,1-.868,1.016l-.612.262,2.088,4.445H350.6l1.814,3.244a.6.6,0,0,0-.283.5V507.2a.607.607,0,0,0,.606.607h2.667a2.991,2.991,0,0,0-.043.563,3.042,3.042,0,0,0,6.083-.091,3.088,3.088,0,0,0-.056-.472h1.326a3.1,3.1,0,1,0,6.146.514,3.212,3.212,0,0,0-.054-.514H370.1l0,.011h9.61a.6.6,0,0,0,.162-.011h1.5a3.234,3.234,0,0,0-.054.573,3.1,3.1,0,1,0,6.21-.041,3.25,3.25,0,0,0-.056-.531h1.517a.3.3,0,0,0,.062.014h2.692a1.067,1.067,0,0,0,.157-.022v-4.168A.606.606,0,0,0,391.3,503.018Zm-14.435-10.7v1.3a1.109,1.109,0,0,0,1.108,1.105h.033l2.376-.075c-.081,2.091-.177,5.059-.177,5.059l-11.128-.14-1.36-2.439a1.94,1.94,0,0,0-1.069-.879l6.793-3.926Zm-20.045,0h10.386l-5.631,2.9-5.49-1.08Z' transform='translate(147.714 1936.516)' fill='%23fff'/%3E%3C/g%3E%3Ctext id='ANQ0678' fill='white' xml:space='preserve' style='white-space: pre' font-family='Roboto, Open Sans, Noto Sans Adlam, sans' font-size='26' font-weight='500' letter-spacing='0em'%3E%3Ctspan x='61.2957' y='37.5435'%3E${licensePlate}%3C/tspan%3E%3C/text%3E%3C/g%3E%3C/svg%3E`;
    case VehicleTypesID.VEICULO_DE_APOIO:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 60 200 80'%3E%3Cg id='Group 170' data-name='Grupo 170'  %3E%3Crect id='Rectangle 135' x='0.256836' y='0.599854' width='199.427' height='55.3551' rx='27.6775' fill='${color}'/%3E%3Cpath id='Caminho 906' d='M28.2576 0.599865C24.5797 0.597136 20.9374 1.31953 17.539 2.72573C14.1405 4.13194 11.0526 6.19435 8.45199 8.79501C5.85133 11.3957 3.78892 14.4835 2.38271 17.882C0.976507 21.2804 0.254114 24.9228 0.256844 28.6006C0.256844 49.6 28.2576 80.5999 28.2576 80.5999C28.2576 80.5999 56.2574 49.6 56.2574 28.6006C56.2609 24.9226 55.5391 21.28 54.1332 17.8813C52.7274 14.4826 50.6651 11.3944 48.0644 8.79362C45.4636 6.19282 42.3756 4.13042 38.9769 2.72444C35.5782 1.31845 31.9356 0.596485 28.2576 0.599865V0.599865Z' fill='${color}'/%3E%3Cg id='Grupo_1301' data-name='Grupo 1301' transform='translate(-310.643 -2412)'%3E%3Cpath id='Caminho_907' fill='${color}' data-name='Caminho 907' d='M263.521,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605s28.325-31.361,28.325-52.605A28.306,28.306,0,0,0,263.521,480.607Z' transform='translate(75.449 1931.393)'/%3E%3Cpath id='Caminho_908' data-name='Caminho 908' d='M281.214,502.119a3.351,3.351,0,0,0-1.019-2.045,1.391,1.391,0,0,1-.495-1.479,4.256,4.256,0,0,0-.538-3.182c-.259-.423-.5-.856-.749-1.275.456-.181-.747-2.2-1.663-2.39a56.2,56.2,0,0,0-7.733-1.129c-1.883-.127-3.774-.148-5.661-.173a12.608,12.608,0,0,0-5.006.914,26.09,26.09,0,0,0-4.157,2.458,10.878,10.878,0,0,1-4.624,1.744,18.892,18.892,0,0,0-3.922.689,6.78,6.78,0,0,0-4.151,3.289,4.545,4.545,0,0,1-1.423,1.851.357.357,0,0,0-.1.278c.043.657.1,1.314.156,1.97a3.969,3.969,0,0,0,.512,2.08,1.639,1.639,0,0,0,1.59.7h0l.732-.006a3.442,3.442,0,0,0,3.387,2.5,3.5,3.5,0,0,0,3.355-2.568l22.858-.213a3.523,3.523,0,0,0,6.908-.064l.7-.006c.808.01.959-.1,1.131-.833A7.048,7.048,0,0,0,281.214,502.119Z' transform='translate(78.268 1937.199)' fill='%23fff'/%3E%3C/g%3E%3Ctext id='ANQ0678' fill='white' xml:space='preserve' style='white-space: pre' font-family='Roboto, Open Sans, Noto Sans Adlam, sans' font-size='26' font-weight='500' letter-spacing='0em'%3E%3Ctspan x='61.2957' y='37.5435'%3E${licensePlate}%3C/tspan%3E%3C/text%3E%3C/g%3E%3C/svg%3E`;
    case VehicleTypesID.PA_CARREGADEIRA:
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 60 200 80'%3E%3Cg id='Group 170' data-name='Grupo 170'  %3E%3Crect id='Rectangle 135' x='0.256836' y='0.599854' width='199.427' height='55.3551' rx='27.6775' fill='${color}'/%3E%3Cpath id='Caminho 906' d='M28.2576 0.599865C24.5797 0.597136 20.9374 1.31953 17.539 2.72573C14.1405 4.13194 11.0526 6.19435 8.45199 8.79501C5.85133 11.3957 3.78892 14.4835 2.38271 17.882C0.976507 21.2804 0.254114 24.9228 0.256844 28.6006C0.256844 49.6 28.2576 80.5999 28.2576 80.5999C28.2576 80.5999 56.2574 49.6 56.2574 28.6006C56.2609 24.9226 55.5391 21.28 54.1332 17.8813C52.7274 14.4826 50.6651 11.3944 48.0644 8.79362C45.4636 6.19282 42.3756 4.13042 38.9769 2.72444C35.5782 1.31845 31.9356 0.596485 28.2576 0.599865V0.599865Z' fill='${color}'/%3E%3Cg id='Grupo_1302' data-name='Grupo 1302' transform='translate(-399.697 -2412)'%3E%3Cpath id='Caminho_909' fill='${color}' data-name='Caminho 909' d='M317.9,480.607a28.3,28.3,0,0,0-28.325,28.327c0,21.244,28.325,52.605,28.325,52.605s28.327-31.361,28.327-52.605A28.306,28.306,0,0,0,317.9,480.607Z' transform='translate(110.12 1931.393)'/%3E%3Cpath id='Caminho_910' data-name='Caminho 910' d='M338.775,504.9l-1.153-7.487-12.334-1.533-1.7-8.02h-8.521l-1.679,7.547h-1.239l-1.562,2.153-4.327-4.386-.046.016v-.016h-4.146c0-.482,0-.964,0-1.446a1.367,1.367,0,0,0-.472-1.172,7.849,7.849,0,0,1-1.005-1.026,1.407,1.407,0,0,0-1.411-.6,4.479,4.479,0,0,1-.642,0c-1.013,2.729-2.012,5.424-3.012,8.118-.258.7-.534,1.388-.771,2.093-.1.307-.234.5-.587.423-.42-.086-.627.108-.736.506s-.277.773-.442,1.224c.2.014.356.033.509.033,2.018,0,4.038.013,6.056-.011a1.187,1.187,0,0,0,.724-.3,6.325,6.325,0,0,0,1.682-1.787,6.549,6.549,0,0,0,.1-2.4c0-.135,0-.27,0-.406h2.377l1.84,6.218c-.173-.014-.34-.052-.517-.052a5.988,5.988,0,1,0,5.866,7.194h11.656a5.988,5.988,0,0,0,11.731,0H336.8Z' transform='translate(112.138 1935.673)' fill='%23fff'/%3E%3C/g%3E%3Ctext id='ANQ0678' fill='white' xml:space='preserve' style='white-space: pre' font-family='Roboto, Open Sans, Noto Sans Adlam, sans' font-size='26' font-weight='500' letter-spacing='0em'%3E%3Ctspan x='61.2957' y='37.5435'%3E${licensePlate}%3C/tspan%3E%3C/text%3E%3C/g%3E%3C/svg%3E`;
    default:
      return "";
    }
  }

  /**
   * Get marker (maps) color according to vehicle type
   * PS: With name
   * @param vehicle Vehicle data
   * @param vehicleTypeID Vehicle type ID
   * @param stateTypeID State type ID
   */
  private getMarkerWithName = (vehicle: GenericVehicle, vehicleTypeID: string, stateTypeID: string) => {
    const color = this.getStateColor(stateTypeID).replace("#", "%23");

    const name = vehicle.code;

    switch (vehicleTypeID) {
    case VehicleTypesID.BETONEIRA:
      return `data:image/svg+xml,%3Csvg viewBox='0 35 149 80' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.244141' y='0.599854' width='148.025' height='55.3551' rx='27.6775' fill='${color}'/%3E%3Cpath d='M28.2449 0.599865C24.567 0.597136 20.9247 1.31953 17.5263 2.72573C14.1278 4.13194 11.0399 6.19435 8.43929 8.79501C5.83863 11.3957 3.77622 14.4835 2.37002 17.882C0.963812 21.2804 0.241419 24.9228 0.244148 28.6006C0.244148 49.6 28.2449 80.5999 28.2449 80.5999C28.2449 80.5999 56.2447 49.6 56.2447 28.6006C56.2482 24.9226 55.5264 21.28 54.1205 17.8813C52.7147 14.4826 50.6524 11.3944 48.0517 8.79362C45.451 6.19282 42.3629 4.13042 38.9642 2.72444C35.5655 1.31845 31.9229 0.596485 28.2449 0.599865V0.599865Z' fill='${color}'/%3E%3Cpath d='M48.3666 30.1755H48.2015V23.6208C48.206 23.2242 48.1548 22.8289 48.0493 22.4465C47.8068 21.5999 47.2904 20.8577 46.5811 20.3359C45.8717 19.8142 45.0093 19.5424 44.129 19.5631C41.8633 19.5552 39.6007 19.5631 37.3351 19.5631C37.28 19.5618 37.2248 19.5645 37.17 19.571C37.1321 19.1731 37.06 18.7792 36.9545 18.3937C36.8771 17.8201 36.6642 17.2731 36.3335 16.798C36.0028 16.3229 35.5637 15.9334 35.0527 15.6615C34.9538 15.6161 34.8688 15.5469 34.771 15.4994C24.6054 10.6015 16.6372 11.2648 10.478 13.1271C10.1582 13.2186 9.86636 13.3884 9.62888 13.6213C8.6153 14.6458 7.94104 15.9571 7.69739 17.3775C7.42538 18.8554 7.43175 20.371 7.71617 21.8465C7.74159 22.2872 7.92845 22.7031 8.24106 23.0149C9.57446 24.2283 11.0061 25.3293 12.5212 26.3065C10.8516 26.7187 9.01702 27.1962 9.01702 27.1962C8.85238 27.1962 8.69448 27.2615 8.57806 27.378C8.46164 27.4944 8.39625 27.6523 8.39625 27.8169V35.0447H11.8777C11.843 35.2434 11.8281 35.4451 11.8332 35.6467C11.8621 36.4589 12.2083 37.2273 12.7975 37.787C13.3867 38.3466 14.172 38.6529 14.9845 38.6399C15.7971 38.627 16.5722 38.2959 17.1433 37.7178C17.7144 37.1396 18.0359 36.3605 18.0389 35.5479C18.0321 35.3819 18.0126 35.2166 17.9806 35.0536C18.4659 35.0536 18.9493 35.0536 19.4248 35.0536C19.3908 35.2478 19.3759 35.4447 19.3803 35.6418C19.3812 36.0743 19.4723 36.5019 19.6477 36.8972C19.8232 37.2925 20.0792 37.647 20.3993 37.9378C20.7195 38.2286 21.0968 38.4495 21.5071 38.5863C21.9174 38.7231 22.3517 38.7729 22.7824 38.7324C23.213 38.6919 23.6305 38.562 24.0081 38.3511C24.3857 38.1401 24.7151 37.8528 24.9754 37.5073C25.2357 37.1619 25.4211 36.766 25.5198 36.3448C25.6184 35.9237 25.6282 35.4866 25.5484 35.0615C26.2908 35.0615 33.0609 35.0615 38.4857 35.0615C38.4166 35.4853 38.4361 35.9188 38.5431 36.3347C38.6501 36.7505 38.8422 37.1396 39.1073 37.4773C39.3723 37.8151 39.7046 38.0943 40.0831 38.2971C40.4615 38.4999 40.878 38.6219 41.306 38.6555C41.7341 38.6891 42.1645 38.6336 42.5699 38.4924C42.9754 38.3511 43.3472 38.1273 43.6618 37.8351C43.9763 37.5428 44.2268 37.1885 44.3974 36.7944C44.568 36.4004 44.655 35.9752 44.6528 35.5459C44.648 35.3839 44.6302 35.2226 44.5995 35.0635H48.8262C48.8807 35.0587 48.9348 35.0508 48.9883 35.0398V30.7893C48.9865 30.6257 48.9202 30.4694 48.8037 30.3545C48.6873 30.2395 48.5302 30.1752 48.3666 30.1755V30.1755Z' fill='white'/%3E%3Ctext fill='white' xml:space='preserve' style='white-space: pre' font-family='Roboto, Open Sans, Noto Sans Adlam, sans' font-size='26' font-weight='500' letter-spacing='0em'%3E%3Ctspan x='61.283' y='37.5435'%3E${name}%3C/tspan%3E%3C/text%3E%3C/svg%3E`;
    case VehicleTypesID.CAMINHAO_BOMBA:
      return `data:image/svg+xml,%3Csvg viewBox='0 35 149 80' fill='none' xmlns='http://www.w3.org/2000/svg' %3E%3Crect x='0.244141' y='0.599854' width='148.025' height='55.3551' rx='27.6775' fill='${color}'/%3E%3Cpath d='M28.2449 0.599865C24.567 0.597136 20.9247 1.31953 17.5263 2.72573C14.1278 4.13194 11.0399 6.19435 8.43929 8.79501C5.83863 11.3957 3.77622 14.4835 2.37002 17.882C0.963812 21.2804 0.241419 24.9228 0.244148 28.6006C0.244148 49.6 28.2449 80.5999 28.2449 80.5999C28.2449 80.5999 56.2447 49.6 56.2447 28.6006C56.2482 24.9226 55.5264 21.28 54.1205 17.8813C52.7147 14.4826 50.6524 11.3944 48.0517 8.79362C45.451 6.19282 42.3629 4.13042 38.9642 2.72444C35.5655 1.31845 31.9229 0.596485 28.2449 0.599865V0.599865Z' fill='${color}'/%3E%3Cg transform='translate(-490.341 -2412)'%3E%3Cpath d='M391.3,503.018h-.165V496.6a4.185,4.185,0,0,0-.146-1.15,3.9,3.9,0,0,0-3.84-2.819c-2.2-.008-4.4,0-6.614,0v-2.155a1.188,1.188,0,0,0-1.188-1.186h-27.44l-.5,1.954a1.513,1.513,0,0,1-.868,1.016l-.612.262,2.088,4.445H350.6l1.814,3.244a.6.6,0,0,0-.283.5V507.2a.607.607,0,0,0,.606.607h2.667a2.991,2.991,0,0,0-.043.563,3.042,3.042,0,0,0,6.083-.091,3.088,3.088,0,0,0-.056-.472h1.326a3.1,3.1,0,1,0,6.146.514,3.212,3.212,0,0,0-.054-.514H370.1l0,.011h9.61a.6.6,0,0,0,.162-.011h1.5a3.234,3.234,0,0,0-.054.573,3.1,3.1,0,1,0,6.21-.041,3.25,3.25,0,0,0-.056-.531h1.517a.3.3,0,0,0,.062.014h2.692a1.067,1.067,0,0,0,.157-.022v-4.168A.606.606,0,0,0,391.3,503.018Zm-14.435-10.7v1.3a1.109,1.109,0,0,0,1.108,1.105h.033l2.376-.075c-.081,2.091-.177,5.059-.177,5.059l-11.128-.14-1.36-2.439a1.94,1.94,0,0,0-1.069-.879l6.793-3.926Zm-20.045,0h10.386l-5.631,2.9-5.49-1.08Z' transform='translate(147.714 1936.516)' fill='white'/%3E%3C/g%3E%3Ctext fill='white' xml:space='preserve' style='white-space: pre' font-family='Roboto, Open Sans, Noto Sans Adlam, sans' font-size='26' font-weight='500' letter-spacing='0em'%3E%3Ctspan x='61.283' y='37.5435'%3E${name}%3C/tspan%3E%3C/text%3E%3C/svg%3E`;
    case VehicleTypesID.VEICULO_DE_APOIO:
      return `data:image/svg+xml,%3Csvg viewBox='0 35 149 80' fill='none' xmlns='http://www.w3.org/2000/svg' %3E%3Crect x='0.244141' y='0.599854' width='148.025' height='55.3551' rx='27.6775' fill='${color}'/%3E%3Cpath d='M28.2449 0.599865C24.567 0.597136 20.9247 1.31953 17.5263 2.72573C14.1278 4.13194 11.0399 6.19435 8.43929 8.79501C5.83863 11.3957 3.77622 14.4835 2.37002 17.882C0.963812 21.2804 0.241419 24.9228 0.244148 28.6006C0.244148 49.6 28.2449 80.5999 28.2449 80.5999C28.2449 80.5999 56.2447 49.6 56.2447 28.6006C56.2482 24.9226 55.5264 21.28 54.1205 17.8813C52.7147 14.4826 50.6524 11.3944 48.0517 8.79362C45.451 6.19282 42.3629 4.13042 38.9642 2.72444C35.5655 1.31845 31.9229 0.596485 28.2449 0.599865V0.599865Z' fill='${color}'/%3E%3Cg transform='translate(-310.643 -2412)'%3E%3Cpath d='M281.214,502.119a3.351,3.351,0,0,0-1.019-2.045,1.391,1.391,0,0,1-.495-1.479,4.256,4.256,0,0,0-.538-3.182c-.259-.423-.5-.856-.749-1.275.456-.181-.747-2.2-1.663-2.39a56.2,56.2,0,0,0-7.733-1.129c-1.883-.127-3.774-.148-5.661-.173a12.608,12.608,0,0,0-5.006.914,26.09,26.09,0,0,0-4.157,2.458,10.878,10.878,0,0,1-4.624,1.744,18.892,18.892,0,0,0-3.922.689,6.78,6.78,0,0,0-4.151,3.289,4.545,4.545,0,0,1-1.423,1.851.357.357,0,0,0-.1.278c.043.657.1,1.314.156,1.97a3.969,3.969,0,0,0,.512,2.08,1.639,1.639,0,0,0,1.59.7h0l.732-.006a3.442,3.442,0,0,0,3.387,2.5,3.5,3.5,0,0,0,3.355-2.568l22.858-.213a3.523,3.523,0,0,0,6.908-.064l.7-.006c.808.01.959-.1,1.131-.833A7.048,7.048,0,0,0,281.214,502.119Z' transform='translate(78.268 1937.199)' fill='white'/%3E%3C/g%3E%3Ctext fill='white' xml:space='preserve' style='white-space: pre' font-family='Roboto, Open Sans, Noto Sans Adlam, sans' font-size='26' font-weight='500' letter-spacing='0em'%3E%3Ctspan x='61.283' y='37.5435'%3E${name}%3C/tspan%3E%3C/text%3E%3C/svg%3E`;
    case VehicleTypesID.PA_CARREGADEIRA:
      return `data:image/svg+xml,%3Csvg viewBox='0 35 149 80' fill='none' xmlns='http://www.w3.org/2000/svg' %3E%3Crect x='0.244141' y='0.599854' width='148.025' height='55.3551' rx='27.6775' fill='${color}'/%3E%3Cpath d='M28.2449 0.599865C24.567 0.597136 20.9247 1.31953 17.5263 2.72573C14.1278 4.13194 11.0399 6.19435 8.43929 8.79501C5.83863 11.3957 3.77622 14.4835 2.37002 17.882C0.963812 21.2804 0.241419 24.9228 0.244148 28.6006C0.244148 49.6 28.2449 80.5999 28.2449 80.5999C28.2449 80.5999 56.2447 49.6 56.2447 28.6006C56.2482 24.9226 55.5264 21.28 54.1205 17.8813C52.7147 14.4826 50.6524 11.3944 48.0517 8.79362C45.451 6.19282 42.3629 4.13042 38.9642 2.72444C35.5655 1.31845 31.9229 0.596485 28.2449 0.599865V0.599865Z' fill='${color}'/%3E%3Cg transform='translate(-399.697 -2412)'%3E%3Cpath id='Caminho_910' data-name='Caminho 910' d='M338.775,504.9l-1.153-7.487-12.334-1.533-1.7-8.02h-8.521l-1.679,7.547h-1.239l-1.562,2.153-4.327-4.386-.046.016v-.016h-4.146c0-.482,0-.964,0-1.446a1.367,1.367,0,0,0-.472-1.172,7.849,7.849,0,0,1-1.005-1.026,1.407,1.407,0,0,0-1.411-.6,4.479,4.479,0,0,1-.642,0c-1.013,2.729-2.012,5.424-3.012,8.118-.258.7-.534,1.388-.771,2.093-.1.307-.234.5-.587.423-.42-.086-.627.108-.736.506s-.277.773-.442,1.224c.2.014.356.033.509.033,2.018,0,4.038.013,6.056-.011a1.187,1.187,0,0,0,.724-.3,6.325,6.325,0,0,0,1.682-1.787,6.549,6.549,0,0,0,.1-2.4c0-.135,0-.27,0-.406h2.377l1.84,6.218c-.173-.014-.34-.052-.517-.052a5.988,5.988,0,1,0,5.866,7.194h11.656a5.988,5.988,0,0,0,11.731,0H336.8Z' transform='translate(112.138 1935.673)' fill='%23fff'/%3E%3C/g%3E%3Ctext fill='white' xml:space='preserve' style='white-space: pre' font-family='Roboto, Open Sans, Noto Sans Adlam, sans' font-size='26' font-weight='500' letter-spacing='0em'%3E%3Ctspan x='61.283' y='37.5435'%3E${name}%3C/tspan%3E%3C/text%3E%3C/svg%3E`;
    default:
      return "";
    }
  }

  /**
   * Get marker (maps) color according to vehicle type
   * PS: With plate and name
   * @param vehicle Vehicle data
   * @param vehicleTypeID Vehicle type ID
   * @param stateTypeID State type ID
   */
  private getMarkerWithNameAndPlate = (vehicle: GenericVehicle, vehicleTypeID: string, stateTypeID: string) => {
    const color = this.getStateColor(stateTypeID).replace("#", "%23");

    const licensePlate = vehicle.license_plate;
    const name = vehicle.code;

    switch (vehicleTypeID) {
    case VehicleTypesID.BETONEIRA:
      return `data:image/svg+xml,%3Csvg viewBox='0 60 200 80' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='198.012' height='55.3551' rx='27.6775' fill='${color}'/%3E%3Cpath d='M28.0008 1.18186e-05C24.3229 -0.00271779 20.6806 0.719675 17.2821 2.12588C13.8837 3.53208 10.7958 5.5945 8.19515 8.19516C5.59449 10.7958 3.53208 13.8837 2.12588 17.2821C0.719671 20.6806 -0.0027219 24.3229 7.70664e-06 28.0008C7.70664e-06 49.0001 28.0008 80 28.0008 80C28.0008 80 56.0006 49.0001 56.0006 28.0008C56.0041 24.3228 55.2823 20.6802 53.8764 17.2814C52.4705 13.8827 50.4082 10.7946 47.8075 8.19377C45.2068 5.59297 42.1187 3.53057 38.7201 2.12458C35.3214 0.718597 31.6788 -0.00336896 28.0008 1.18186e-05V1.18186e-05Z' fill='${color}'/%3E%3Cpath d='M48.1225 29.5757H47.9574V23.0211C47.9619 22.6244 47.9107 22.2291 47.8052 21.8467C47.5627 21.0002 47.0463 20.2579 46.3369 19.7362C45.6276 19.2144 44.7652 18.9426 43.8848 18.9633C41.6192 18.9554 39.3566 18.9633 37.091 18.9633C37.0359 18.9621 36.9807 18.9647 36.9259 18.9713C36.888 18.5734 36.8159 18.1795 36.7104 17.794C36.633 17.2203 36.4201 16.6733 36.0894 16.1983C35.7587 15.7232 35.3196 15.3336 34.8086 15.0618C34.7097 15.0163 34.6247 14.9471 34.5269 14.8997C24.3613 10.0017 16.3931 10.665 10.2339 12.5273C9.91413 12.6188 9.62226 12.7887 9.38478 13.0216C8.3712 14.0461 7.69694 15.3573 7.45329 16.7778C7.18128 18.2556 7.18764 19.7713 7.47206 21.2467C7.49749 21.6875 7.68435 22.1034 7.99695 22.4151C9.33036 23.6286 10.762 24.7296 12.2771 25.7068C10.6075 26.119 8.77292 26.5964 8.77292 26.5964C8.60828 26.5964 8.45037 26.6618 8.33396 26.7782C8.21754 26.8946 8.15214 27.0525 8.15214 27.2172V34.445H11.6336C11.5989 34.6437 11.584 34.8453 11.5891 35.047C11.618 35.8591 11.9642 36.6275 12.5534 37.1872C13.1426 37.7469 13.9279 38.0531 14.7404 38.0402C15.553 38.0273 16.3281 37.6962 16.8992 37.118C17.4703 36.5399 17.7918 35.7608 17.7948 34.9481C17.788 34.7821 17.7685 34.6169 17.7365 34.4539C18.2218 34.4539 18.7052 34.4539 19.1807 34.4539C19.1467 34.648 19.1318 34.845 19.1362 35.042C19.1371 35.4745 19.2282 35.9021 19.4036 36.2974C19.5791 36.6928 19.8351 37.0472 20.1552 37.3381C20.4754 37.6289 20.8527 37.8498 21.263 37.9866C21.6733 38.1234 22.1076 38.1731 22.5383 38.1326C22.9689 38.0921 23.3864 37.9623 23.764 37.7513C24.1416 37.5404 24.471 37.253 24.7313 36.9076C24.9916 36.5621 25.177 36.1662 25.2757 35.7451C25.3743 35.324 25.3841 34.8869 25.3043 34.4618C26.0467 34.4618 32.8168 34.4618 38.2416 34.4618C38.1725 34.8855 38.192 35.3191 38.299 35.7349C38.406 36.1507 38.5981 36.5398 38.8632 36.8776C39.1282 37.2154 39.4605 37.4945 39.839 37.6973C40.2174 37.9001 40.6339 38.0221 41.0619 38.0558C41.49 38.0894 41.9203 38.0339 42.3258 37.8926C42.7313 37.7514 43.1031 37.5276 43.4177 37.2353C43.7322 36.943 43.9827 36.5887 44.1533 36.1947C44.3239 35.8007 44.4109 35.3755 44.4087 34.9461C44.4039 34.7842 44.3861 34.6228 44.3554 34.4637H48.5821C48.6366 34.459 48.6907 34.4511 48.7442 34.44V30.1896C48.7424 30.0259 48.6761 29.8697 48.5596 29.7547C48.4432 29.6398 48.2861 29.5754 48.1225 29.5757V29.5757Z' fill='white'/%3E%3Ctext fill='white' xml:space='preserve' style='white-space: pre' font-family='Roboto, Open Sans, Noto Sans Adlam, sans' font-size='24' font-weight='500' letter-spacing='0em'%3E%3Ctspan x='60.7891' y='21.9746'%3E${name}&%2310;%3C/tspan%3E%3Ctspan x='60.7891' y='47.9746'%3E${licensePlate}%3C/tspan%3E%3C/text%3E%3C/svg%3E`;
    case VehicleTypesID.CAMINHAO_BOMBA:
      return `data:image/svg+xml,%3Csvg viewBox='0 60 200 80' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='198.012' height='55.3551' rx='27.6775' fill='${color}'/%3E%3Cpath d='M28.0008 1.18186e-05C24.3229 -0.00271779 20.6806 0.719675 17.2821 2.12588C13.8837 3.53208 10.7958 5.5945 8.19515 8.19516C5.59449 10.7958 3.53208 13.8837 2.12588 17.2821C0.719671 20.6806 -0.0027219 24.3229 7.70664e-06 28.0008C7.70664e-06 49.0001 28.0008 80 28.0008 80C28.0008 80 56.0006 49.0001 56.0006 28.0008C56.0041 24.3228 55.2823 20.6802 53.8764 17.2814C52.4705 13.8827 50.4082 10.7946 47.8075 8.19377C45.2068 5.59297 42.1187 3.53057 38.7201 2.12458C35.3214 0.718597 31.6788 -0.00336896 28.0008 1.18186e-05V1.18186e-05Z' fill='${color}'/%3E%3Cg transform='translate(-490.341 -2412)'%3E%3Cpath d='M391.3,503.018h-.165V496.6a4.185,4.185,0,0,0-.146-1.15,3.9,3.9,0,0,0-3.84-2.819c-2.2-.008-4.4,0-6.614,0v-2.155a1.188,1.188,0,0,0-1.188-1.186h-27.44l-.5,1.954a1.513,1.513,0,0,1-.868,1.016l-.612.262,2.088,4.445H350.6l1.814,3.244a.6.6,0,0,0-.283.5V507.2a.607.607,0,0,0,.606.607h2.667a2.991,2.991,0,0,0-.043.563,3.042,3.042,0,0,0,6.083-.091,3.088,3.088,0,0,0-.056-.472h1.326a3.1,3.1,0,1,0,6.146.514,3.212,3.212,0,0,0-.054-.514H370.1l0,.011h9.61a.6.6,0,0,0,.162-.011h1.5a3.234,3.234,0,0,0-.054.573,3.1,3.1,0,1,0,6.21-.041,3.25,3.25,0,0,0-.056-.531h1.517a.3.3,0,0,0,.062.014h2.692a1.067,1.067,0,0,0,.157-.022v-4.168A.606.606,0,0,0,391.3,503.018Zm-14.435-10.7v1.3a1.109,1.109,0,0,0,1.108,1.105h.033l2.376-.075c-.081,2.091-.177,5.059-.177,5.059l-11.128-.14-1.36-2.439a1.94,1.94,0,0,0-1.069-.879l6.793-3.926Zm-20.045,0h10.386l-5.631,2.9-5.49-1.08Z' transform='translate(147.714 1936.516)' fill='white'/%3E%3C/g%3E%3Ctext fill='white' xml:space='preserve' style='white-space: pre' font-family='Roboto, Open Sans, Noto Sans Adlam, sans' font-size='24' font-weight='500' letter-spacing='0em'%3E%3Ctspan x='60.7891' y='21.9746'%3E${name}&%2310;%3C/tspan%3E%3Ctspan x='60.7891' y='47.9746'%3E${licensePlate}%3C/tspan%3E%3C/text%3E%3C/svg%3E`;
    case VehicleTypesID.VEICULO_DE_APOIO:
      return `data:image/svg+xml,%3Csvg viewBox='0 60 200 80' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='198.012' height='55.3551' rx='27.6775' fill='${color}'/%3E%3Cpath d='M28.0008 1.18186e-05C24.3229 -0.00271779 20.6806 0.719675 17.2821 2.12588C13.8837 3.53208 10.7958 5.5945 8.19515 8.19516C5.59449 10.7958 3.53208 13.8837 2.12588 17.2821C0.719671 20.6806 -0.0027219 24.3229 7.70664e-06 28.0008C7.70664e-06 49.0001 28.0008 80 28.0008 80C28.0008 80 56.0006 49.0001 56.0006 28.0008C56.0041 24.3228 55.2823 20.6802 53.8764 17.2814C52.4705 13.8827 50.4082 10.7946 47.8075 8.19377C45.2068 5.59297 42.1187 3.53057 38.7201 2.12458C35.3214 0.718597 31.6788 -0.00336896 28.0008 1.18186e-05V1.18186e-05Z' fill='${color}'/%3E%3Cg transform='translate(-310.643 -2412)'%3E%3Cpath d='M281.214,502.119a3.351,3.351,0,0,0-1.019-2.045,1.391,1.391,0,0,1-.495-1.479,4.256,4.256,0,0,0-.538-3.182c-.259-.423-.5-.856-.749-1.275.456-.181-.747-2.2-1.663-2.39a56.2,56.2,0,0,0-7.733-1.129c-1.883-.127-3.774-.148-5.661-.173a12.608,12.608,0,0,0-5.006.914,26.09,26.09,0,0,0-4.157,2.458,10.878,10.878,0,0,1-4.624,1.744,18.892,18.892,0,0,0-3.922.689,6.78,6.78,0,0,0-4.151,3.289,4.545,4.545,0,0,1-1.423,1.851.357.357,0,0,0-.1.278c.043.657.1,1.314.156,1.97a3.969,3.969,0,0,0,.512,2.08,1.639,1.639,0,0,0,1.59.7h0l.732-.006a3.442,3.442,0,0,0,3.387,2.5,3.5,3.5,0,0,0,3.355-2.568l22.858-.213a3.523,3.523,0,0,0,6.908-.064l.7-.006c.808.01.959-.1,1.131-.833A7.048,7.048,0,0,0,281.214,502.119Z' transform='translate(78.268 1937.199)' fill='white'/%3E%3C/g%3E%3Ctext fill='white' xml:space='preserve' style='white-space: pre' font-family='Roboto, Open Sans, Noto Sans Adlam, sans' font-size='24' font-weight='500' letter-spacing='0em'%3E%3Ctspan x='60.7891' y='21.9746'%3E${name}&%2310;%3C/tspan%3E%3Ctspan x='60.7891' y='47.9746'%3E${licensePlate}%3C/tspan%3E%3C/text%3E%3C/svg%3E`;
    case VehicleTypesID.PA_CARREGADEIRA:
      return `data:image/svg+xml,%3Csvg viewBox='0 60 200 80' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='198.012' height='55.3551' rx='27.6775' fill='${color}'/%3E%3Cpath d='M28.0008 1.18186e-05C24.3229 -0.00271779 20.6806 0.719675 17.2821 2.12588C13.8837 3.53208 10.7958 5.5945 8.19515 8.19516C5.59449 10.7958 3.53208 13.8837 2.12588 17.2821C0.719671 20.6806 -0.0027219 24.3229 7.70664e-06 28.0008C7.70664e-06 49.0001 28.0008 80 28.0008 80C28.0008 80 56.0006 49.0001 56.0006 28.0008C56.0041 24.3228 55.2823 20.6802 53.8764 17.2814C52.4705 13.8827 50.4082 10.7946 47.8075 8.19377C45.2068 5.59297 42.1187 3.53057 38.7201 2.12458C35.3214 0.718597 31.6788 -0.00336896 28.0008 1.18186e-05V1.18186e-05Z' fill='${color}'/%3E%3Cg transform='translate(-399.697 -2412)'%3E%3Cpath d='M338.775,504.9l-1.153-7.487-12.334-1.533-1.7-8.02h-8.521l-1.679,7.547h-1.239l-1.562,2.153-4.327-4.386-.046.016v-.016h-4.146c0-.482,0-.964,0-1.446a1.367,1.367,0,0,0-.472-1.172,7.849,7.849,0,0,1-1.005-1.026,1.407,1.407,0,0,0-1.411-.6,4.479,4.479,0,0,1-.642,0c-1.013,2.729-2.012,5.424-3.012,8.118-.258.7-.534,1.388-.771,2.093-.1.307-.234.5-.587.423-.42-.086-.627.108-.736.506s-.277.773-.442,1.224c.2.014.356.033.509.033,2.018,0,4.038.013,6.056-.011a1.187,1.187,0,0,0,.724-.3,6.325,6.325,0,0,0,1.682-1.787,6.549,6.549,0,0,0,.1-2.4c0-.135,0-.27,0-.406h2.377l1.84,6.218c-.173-.014-.34-.052-.517-.052a5.988,5.988,0,1,0,5.866,7.194h11.656a5.988,5.988,0,0,0,11.731,0H336.8Z' transform='translate(112.138 1935.673)' fill='white'/%3E%3C/g%3E%3Ctext fill='white' xml:space='preserve' style='white-space: pre' font-family='Roboto, Open Sans, Noto Sans Adlam, sans' font-size='24' font-weight='500' letter-spacing='0em'%3E%3Ctspan x='60.7891' y='21.9746'%3E${name}&%2310;%3C/tspan%3E%3Ctspan x='60.7891' y='47.9746'%3E${licensePlate}%3C/tspan%3E%3C/text%3E%3C/svg%3E`;
    default:
      return "";
    }
  }

}

export default new Utils();
